import { NovenaType, NovenaInfo, NovenaDay } from '../types';

export const NOVENA_INFO: Record<NovenaType, NovenaInfo> = {
  'divine-mercy': {
    name: 'Divine Mercy Novena',
    description: 'Nine days of prayer to Jesus\' Divine Mercy',
    color: '#dc2626', // red-600 - good contrast
    icon: '✝️',
    patron: 'Jesus Christ',
    feastDay: 'Divine Mercy Sunday',
    estimatedDuration: 15
  },
  'sacred-heart': {
    name: 'Sacred Heart Novena',
    description: 'Nine days of devotion to the Sacred Heart of Jesus',
    color: '#d97706', // amber-600 - better than gold
    icon: '❤️',
    patron: 'Jesus Christ',
    feastDay: 'Sacred Heart Friday',
    estimatedDuration: 18
  },
  'st-joseph': {
    name: 'St. Joseph Novena',
    description: 'Nine days of prayer to the patron of workers and families',
    color: '#92400e', // amber-800 - dark brown for contrast
    icon: '🔨',
    patron: 'St. Joseph',
    feastDay: 'March 19',
    estimatedDuration: 12
  },
  'immaculate-heart': {
    name: 'Immaculate Heart Novena',
    description: 'Nine days of prayer to Mary\'s Immaculate Heart',
    color: '#2563eb', // blue-600 - good contrast
    icon: '💝',
    patron: 'Blessed Virgin Mary',
    feastDay: 'August 22',
    estimatedDuration: 20
  },
  'st-therese': {
    name: 'St. Thérèse Novena',
    description: 'Nine days of prayer to the Little Flower',
    color: '#db2777', // pink-600 - better than light pink
    icon: '🌹',
    patron: 'St. Thérèse of Lisieux',
    feastDay: 'October 1',
    estimatedDuration: 15
  },
  'st-jude': {
    name: 'St. Jude Novena',
    description: 'Nine days of prayer to the patron of hopeless causes',
    color: '#16a34a', // green-600 - good contrast
    icon: '🕯️',
    patron: 'St. Jude Thaddeus',
    feastDay: 'October 28',
    estimatedDuration: 14
  },
  'st-anthony': {
    name: 'St. Anthony Novena',
    description: 'Nine days of prayer to the finder of lost things',
    color: '#a16207', // yellow-700 - different from st-joseph
    icon: '🙏',
    patron: 'St. Anthony of Padua',
    feastDay: 'June 13',
    estimatedDuration: 16
  },
  'blessed-mother': {
    name: 'Blessed Mother Novena',
    description: 'Nine days of prayer to Our Lady',
    color: '#1d4ed8', // blue-700 - darker than immaculate-heart
    icon: '👑',
    patron: 'Blessed Virgin Mary',
    feastDay: 'Various',
    estimatedDuration: 18
  },
  'holy-spirit': {
    name: 'Holy Spirit Novena',
    description: 'Nine days of prayer for the gifts of the Holy Spirit',
    color: '#b91c1c', // red-700 - darker than divine-mercy
    icon: '🕊️',
    patron: 'Holy Spirit',
    feastDay: 'Pentecost',
    estimatedDuration: 20
  },
  'our-lady-of-confidence': {
    name: 'Our Lady of Confidence Novena',
    description: 'Nine days of prayer seeking Mary\'s protection and intercession',
    color: '#0284c7', // sky-600
    icon: '🌟',
    patron: 'Blessed Virgin Mary',
    feastDay: 'February 27',
    estimatedDuration: 12
  },
  'st-george': {
    name: 'St. George Novena',
    description: 'Nine days of prayer to the patron of soldiers and courage',
    color: '#dc2626', // red-600
    icon: '⚔️',
    patron: 'St. George',
    feastDay: 'April 23',
    estimatedDuration: 12
  },
  'st-alexander': {
    name: 'St. Alexander Novena',
    description: 'Nine days of prayer to the bishop and martyr of Jerusalem',
    color: '#7c3aed', // violet-600
    icon: '✝️',
    patron: 'St. Alexander of Jerusalem',
    feastDay: 'March 18',
    estimatedDuration: 12
  },
  'st-benedict': {
    name: 'St. Benedict Novena',
    description: 'Nine days of prayer to the father of Western monasticism',
    color: '#1f2937', // gray-800
    icon: '📿',
    patron: 'St. Benedict',
    feastDay: 'July 11',
    estimatedDuration: 15
  },
  'st-thomas-aquinas': {
    name: 'St. Thomas Aquinas Novena',
    description: 'Nine days of prayer to the Angelic Doctor',
    color: '#1d4ed8', // blue-700
    icon: '📚',
    patron: 'St. Thomas Aquinas',
    feastDay: 'January 28',
    estimatedDuration: 14
  },
  'mother-teresa': {
    name: 'Mother Teresa Novena',
    description: 'Nine days of prayer to St. Teresa of Calcutta',
    color: '#0369a1', // sky-700
    icon: '💙',
    patron: 'St. Teresa of Calcutta',
    feastDay: 'September 5',
    estimatedDuration: 15
  },
  'st-monica': {
    name: 'St. Monica Novena',
    description: 'Nine days of prayer for wayward children and conversion',
    color: '#7e22ce', // purple-700
    icon: '💜',
    patron: 'St. Monica',
    feastDay: 'August 27',
    estimatedDuration: 12
  },
  'guardian-angel': {
    name: 'Guardian Angel Novena',
    description: 'Nine days of prayer to your heavenly protector',
    color: '#f59e0b', // amber-500
    icon: '👼',
    patron: 'Guardian Angels',
    feastDay: 'October 2',
    estimatedDuration: 12
  },
  'healing-childhood-trauma': {
    name: 'Healing from Childhood Trauma Novena',
    description: 'Nine days of prayer for healing and restoration',
    color: '#059669', // emerald-600
    icon: '🕊️',
    patron: 'Jesus Christ',
    feastDay: 'Various',
    estimatedDuration: 15
  },
  'st-carlo-acutis': {
    name: 'St. Carlo Acutis Novena',
    description: 'Nine days of prayer to the patron of the internet and youth',
    color: '#3b82f6', // blue-500
    icon: '💻',
    patron: 'St. Carlo Acutis',
    feastDay: 'October 12',
    estimatedDuration: 10
  },
  'st-isidore': {
    name: 'St. Isidore the Farmer Novena',
    description: 'Nine days of prayer to the patron of farmers and laborers',
    color: '#65a30d', // lime-600
    icon: '🌾',
    patron: 'St. Isidore the Farmer',
    feastDay: 'May 15',
    estimatedDuration: 10
  },
  'padre-pio': {
    name: 'St. Padre Pio Novena',
    description: 'Nine days of prayer to the stigmatist and confessor',
    color: '#78350f', // amber-900
    icon: '🙏',
    patron: 'St. Pio of Pietrelcina',
    feastDay: 'September 23',
    estimatedDuration: 12
  },
  'infant-of-prague': {
    name: 'Infant Jesus of Prague Novena',
    description: 'Nine days of prayer meditating on the Beatitudes',
    color: '#dc2626', // red-600
    icon: '👶',
    patron: 'Infant Jesus of Prague',
    feastDay: 'January 14',
    estimatedDuration: 10
  },
  'our-lady-perpetual-help': {
    name: 'Our Lady of Perpetual Help Novena',
    description: 'Nine days of prayer to Mary under this ancient title',
    color: '#7c3aed', // violet-600
    icon: '🌹',
    patron: 'Our Lady of Perpetual Help',
    feastDay: 'June 27',
    estimatedDuration: 12
  },
  'st-rita': {
    name: 'St. Rita of Cascia Novena',
    description: 'Nine days of prayer to the patron of impossible causes',
    color: '#be123c', // rose-700
    icon: '🌹',
    patron: 'St. Rita of Cascia',
    feastDay: 'May 22',
    estimatedDuration: 12
  },
  'st-michael': {
    name: 'St. Michael the Archangel Novena',
    description: 'Nine days of prayer to the prince of angels',
    color: '#1e40af', // blue-800
    icon: '⚔️',
    patron: 'St. Michael the Archangel',
    feastDay: 'September 29',
    estimatedDuration: 10
  },
  'st-gerard': {
    name: 'St. Gerard Majella Novena',
    description: 'Nine days of prayer for expectant mothers and children',
    color: '#059669', // emerald-600
    icon: '👶',
    patron: 'St. Gerard Majella',
    feastDay: 'October 16',
    estimatedDuration: 12
  },
  'st-peregrine': {
    name: 'St. Peregrine Novena',
    description: 'Nine days of prayer for healing from cancer and illness',
    color: '#0891b2', // cyan-600
    icon: '✝️',
    patron: 'St. Peregrine',
    feastDay: 'May 1',
    estimatedDuration: 12
  }
};

export const NOVENA_PRAYERS: Record<NovenaType, NovenaDay[]> = {
  'divine-mercy': [
    {
      day: 1,
      title: 'Day 1 - All Mankind',
      content: [
        'Opening Prayer:',
        'You expired, Jesus, but the source of life gushed forth for souls, and the ocean of mercy opened up for the whole world. O Fount of Life, unfathomable Divine Mercy, envelop the whole world and empty Yourself out upon us.',
        '',
        'Today bring to Me all mankind, especially all sinners, and immerse them in the ocean of My mercy. In this way you will console Me in the bitter grief into which the loss of souls plunges Me.',
        '',
        'Most Merciful Jesus, whose very nature it is to have compassion on us and to forgive, do not look upon our sins but upon our trust which we place in Your infinite goodness. Receive us all into the abode of Your Most Compassionate Heart, and never let us escape from It. We beg this of You by Your love which unites You to the Father and the Holy Spirit.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I show greater mercy and compassion to all people I encounter today?',
      scripture: 'But God, who is rich in mercy, out of the great love with which he loved us, even when we were dead through our trespasses, made us alive together with Christ. (Ephesians 2:4-5)'
    },
    {
      day: 2,
      title: 'Day 2 - Souls of Priests and Religious',
      content: [
        'Today bring to Me the souls of priests and religious, and immerse them in My unfathomable mercy. It was they who gave Me strength to endure My bitter Passion. Through them flows My mercy unto mankind.',
        '',
        'Most Merciful Jesus, from whom comes all that is good, increase Your grace in men and women consecrated to Your service, that they may perform worthy works of mercy; and that all who see them may glorify the Father of Mercy who is in heaven.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I better support and pray for those who have dedicated their lives to serving God?',
      scripture: 'And he said to them, "The harvest is plentiful, but the laborers are few; pray therefore the Lord of the harvest to send out laborers into his harvest." (Luke 10:2)'
    },
    // Days 3-9 would follow the same pattern
    {
      day: 3,
      title: 'Day 3 - All Devout and Faithful Souls',
      content: [
        'Today bring to Me all devout and faithful souls, and immerse them in the ocean of My mercy. These souls brought Me consolation on the Way of the Cross. They were a drop of consolation in the midst of an ocean of bitterness.',
        '',
        'Most Merciful Jesus, from the treasury of Your mercy, You impart Your graces; and we, with broken hearts, with deep humility, fly to Your mercy. Take under Your special protection all devout and faithful souls, and keep them from falling away from love and the desire for perfection. Bless their endeavors and grant that they may persevere in mercy and continue to be living examples of goodness for others.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I deepen my own devotion and faithfulness to God today?',
      scripture: 'Be faithful unto death, and I will give you the crown of life. (Revelation 2:10)'
    },
    {
      day: 4,
      title: 'Day 4 - Those Who Do Not Know Jesus',
      content: [
        'Today bring to Me those who do not know Me, and those who do not yet believe. I was thinking also of them during My bitter Passion, and their future zeal comforted My Heart. Immerse them in the ocean of My mercy.',
        '',
        'Most compassionate Jesus, You are the Light of the whole world. Receive into the abode of Your Most Compassionate Heart the souls of those who do not yet know You. Let the rays of Your grace enlighten them that they, too, together with us, may extol Your wonderful mercy; and do not let them escape from the abode of Your Most Compassionate Heart.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I be a witness to God\'s love for those who have not yet encountered Him?',
      scripture: 'And I have other sheep, that are not of this fold; I must bring them also, and they will heed my voice. So there shall be one flock, one shepherd. (John 10:16)'
    },
    {
      day: 5,
      title: 'Day 5 - The Souls of Separated Brethren',
      content: [
        'Today bring to Me the souls of those who have separated themselves from My Church, and immerse them in the ocean of My mercy. During My bitter Passion they tore at My Body and Heart, that is, My Church. As they return to unity with the Church, My wounds heal and in this way they alleviate My Passion.',
        '',
        'Most Merciful Jesus, Goodness Itself, You do not refuse light to those who seek it of You. Receive into the abode of Your Most Compassionate Heart the souls of those who have separated themselves from Your Church. Draw them by Your light into the unity of the Church, and do not let them escape from the abode of Your Most Compassionate Heart; but bring it about that they, too, come to glorify the generosity of Your mercy.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I pray for and work toward greater unity among all Christians?',
      scripture: 'That they may all be one; even as you, Father, are in me, and I in you, that they also may be in us, so that the world may believe that you have sent me. (John 17:21)'
    },
    {
      day: 6,
      title: 'Day 6 - The Meek and Humble Souls',
      content: [
        'Today bring to Me the meek and humble souls and the souls of children, and immerse them in My mercy. These souls most closely resemble My Heart. They strengthened Me during My bitter agony. I saw them as earthly angels, who will keep vigil at My altars. I pour out upon them whole torrents of grace. Only the humble soul is capable of receiving My grace.',
        '',
        'Most Merciful Jesus, You yourself have said, "Learn from Me for I am meek and humble of heart." Receive into the abode of Your Most Compassionate Heart all meek and humble souls and the souls of children. These souls send all heaven into ecstasy and they are the heavenly Father\'s favorites. They are a sweet-smelling bouquet before the throne of God; God Himself takes delight in their fragrance. These souls have a permanent place in Your Most Compassionate Heart, O Jesus, and they unceasingly sing out a hymn of love and mercy.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I cultivate greater humility and meekness in my daily life?',
      scripture: 'Truly, I say to you, unless you turn and become like children, you will never enter the kingdom of heaven. (Matthew 18:3)'
    },
    {
      day: 7,
      title: 'Day 7 - The Souls Who Especially Venerate My Mercy',
      content: [
        'Today bring to Me the souls who especially revere and glorify My mercy, and immerse them in My mercy. These souls sorrowed most over My Passion and entered most deeply into My spirit. They are living images of My Compassionate Heart. These souls will shine with a special brightness in the next life. Not one of them will go into the fire of hell. I shall particularly defend each one of them at the hour of death.',
        '',
        'Most Merciful Jesus, whose Heart is Love Itself, receive into the abode of Your Most Compassionate Heart the souls of those who particularly extol and venerate the greatness of Your mercy. These souls are mighty with the very power of God Himself. In the midst of all afflictions and adversities they go forward, confident of Your mercy; and united to You, O Jesus, they carry all mankind on their shoulders. These souls will not be judged severely, but Your mercy will embrace them as they depart from this life.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I grow in my devotion to God\'s mercy and share it with others?',
      scripture: 'Blessed are the merciful, for they shall obtain mercy. (Matthew 5:7)'
    },
    {
      day: 8,
      title: 'Day 8 - The Souls Who Are Detained in Purgatory',
      content: [
        'Today bring to Me the souls who are detained in Purgatory, and immerse them in the abyss of My mercy. Let the torrents of My Blood cool down their scorching flames. All these souls are greatly loved by Me. They are making retribution to My justice. It is in your power to bring them relief. Draw all the indulgences from the treasury of My Church and offer them on their behalf. Oh, if you only knew the torments they suffer, you would continually offer for them the alms of the spirit and pay off their debt to My justice.',
        '',
        'Most Merciful Jesus, You Yourself have said that You desire mercy; so I bring into the abode of Your Most Compassionate Heart the souls in Purgatory, souls who are very dear to You, and yet, who must make retribution to Your justice. May the streams of Blood and Water which gushed forth from Your Heart put out the flames of Purgatory, that there, too, the power of Your mercy may be celebrated.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I remember to pray for the souls of the departed and offer sacrifices for them?',
      scripture: 'It is therefore a holy and wholesome thought to pray for the dead, that they may be loosed from their sins. (2 Maccabees 12:46)'
    },
    {
      day: 9,
      title: 'Day 9 - The Souls Who Have Become Lukewarm',
      content: [
        'Today bring to Me the souls who have become lukewarm, and immerse them in the abyss of My mercy. These souls wound My Heart most painfully. My soul suffered the most dreadful loathing in the Garden of Olives because of lukewarm souls. They were the reason I cried out: "Father, take this cup away from Me, if it be Your will." For them, the last hope of salvation is to run to My mercy.',
        '',
        'Most compassionate Jesus, You are Compassion Itself. I bring lukewarm souls into the abode of Your Most Compassionate Heart. In this fire of Your pure love, let these tepid souls who, like corpses, filled You with such deep loathing, be once again set aflame. O Most Compassionate Jesus, exercise the omnipotence of Your mercy and draw them into the very ardor of Your love, and bestow upon them the gift of holy love, for nothing is beyond Your power.'
      ],
      prayer: 'Eternal Father, I offer you the Body and Blood, Soul and Divinity of Your Dearly Beloved Son, Our Lord, Jesus Christ, in atonement for our sins and those of the whole world. For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      reflection: 'How can I reignite my passion for God and avoid spiritual lukewarmness in my own life?',
      scripture: 'I know your works: you are neither cold nor hot. Would that you were cold or hot! So, because you are lukewarm, and neither cold nor hot, I will spew you out of my mouth. (Revelation 3:15-16)'
    }
  ],
  'sacred-heart': [
    {
      day: 1,
      title: 'Day 1 - Love of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, burning with infinite love for us poor sinners, and especially for those who love You, we place all our trust in You. We consecrate ourselves entirely to You. Be You our guide, our strength, and our refuge, especially at the hour of death.',
        '',
        'Never permit us to offend You again. Give us grace to love You more and more, and to make You loved by others. Grant that we may live and die in Your holy love.'
      ],
      prayer: 'Sacred Heart of Jesus, I believe in Your love for me. Amen.',
      reflection: 'How can I open my heart more fully to receive and share the infinite love of Jesus?',
      scripture: 'And he took bread, and when he had given thanks, he broke it and gave it to them, saying, "This is my body, which is given for you. Do this in remembrance of me." (Luke 22:19)'
    },
    {
      day: 2,
      title: 'Day 2 - Mercy of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, fountain of infinite mercy, from which flow all graces and blessings, I worship and adore You. I am sorry for my sins, which have wounded Your loving Heart. Give me the grace to repent sincerely and to amend my life.',
        '',
        'Pour forth Your mercy upon all sinners, especially those who are in most need of Your compassion. Convert the hearts of all who have wandered from You, and bring them back to Your Sacred Heart.'
      ],
      prayer: 'Sacred Heart of Jesus, have mercy on us. Amen.',
      reflection: 'How can I be more merciful to others, as Jesus is merciful to me?',
      scripture: 'But God, being rich in mercy, because of the great love with which he loved us, even when we were dead in our trespasses, made us alive together with Christ. (Ephesians 2:4-5)'
    },
    {
      day: 3,
      title: 'Day 3 - Patience of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, model of patience in all trials and sufferings, teach me to be patient in all the crosses and difficulties of life. Help me to accept with resignation whatever You permit to happen to me.',
        '',
        'Grant me the grace to endure patiently all the sufferings of this life, in union with Your own Sacred Passion. Let me never complain or grow bitter, but always trust in Your divine Providence.'
      ],
      prayer: 'Sacred Heart of Jesus, grant me patience in all my trials. Amen.',
      reflection: 'How can I grow in patience, especially when facing difficult situations or difficult people?',
      scripture: 'But if we hope for what we do not see, we wait for it with patience. (Romans 8:25)'
    },
    {
      day: 4,
      title: 'Day 4 - Humility of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, perfect model of humility, who emptied Yourself to become like us in all things except sin, teach me true humility. Help me to recognize my nothingness before God and my total dependence on Your grace.',
        '',
        'Grant that I may never seek my own glory, but in all things seek only to glorify You. Let me be content to be unknown and overlooked by the world, as long as I am known and loved by You.'
      ],
      prayer: 'Sacred Heart of Jesus, make my heart humble like Yours. Amen.',
      reflection: 'Where do I struggle with pride? How can I grow in true humility before God and others?',
      scripture: 'Take my yoke upon you, and learn from me, for I am gentle and humble in heart, and you will find rest for your souls. (Matthew 11:29)'
    },
    {
      day: 5,
      title: 'Day 5 - Obedience of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, perfect example of obedience to the Father\'s will, who became obedient even unto death on the Cross, teach me to be obedient to God\'s will in all things. Help me to say "yes" to whatever God asks of me, as You always did.',
        '',
        'Grant me the grace to obey not only in great things, but also in the small duties of everyday life. Let me find joy in doing God\'s will, knowing that this is the path to true happiness and holiness.'
      ],
      prayer: 'Sacred Heart of Jesus, help me to be obedient to God\'s will. Amen.',
      reflection: 'How can I better discern and follow God\'s will in my daily decisions and choices?',
      scripture: 'And being found in human form, he humbled himself by becoming obedient to the point of death, even death on a cross. (Philippians 2:8)'
    },
    {
      day: 6,
      title: 'Day 6 - Meekness of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, meek and gentle in all Your ways, teach me to be meek and gentle like You. Help me to respond to anger with kindness, to insults with blessings, and to hatred with love.',
        '',
        'Grant me the grace to control my temper and to speak always with gentleness and charity. Let Your meekness shine through me, so that others may see Your love in my words and actions.'
      ],
      prayer: 'Sacred Heart of Jesus, make my heart meek and gentle like Yours. Amen.',
      reflection: 'How can I respond to difficult people and situations with the meekness and gentleness of Jesus?',
      scripture: 'Blessed are the meek, for they shall inherit the earth. (Matthew 5:5)'
    },
    {
      day: 7,
      title: 'Day 7 - Zeal of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, burning with zeal for the glory of God and the salvation of souls, inflame my heart with that same holy zeal. Help me to work tirelessly for the Kingdom of God and to bring others to know and love You.',
        '',
        'Grant me the courage to speak of You to others, and to live my faith boldly and without compromise. Let my life be a witness to Your love and truth, drawing others closer to Your Sacred Heart.'
      ],
      prayer: 'Sacred Heart of Jesus, inflame my heart with zeal for Your glory. Amen.',
      reflection: 'How can I share my faith more boldly and work for the salvation of souls?',
      scripture: 'Zeal for your house will consume me. (John 2:17)'
    },
    {
      day: 8,
      title: 'Day 8 - Compassion of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, moved with compassion for all who suffer, open my heart to feel genuine compassion for others. Help me to see the suffering around me and to respond with kindness and practical help.',
        '',
        'Grant me the grace to comfort those who mourn, to help those in need, and to be Your hands and feet in a world that desperately needs Your love. Let Your compassion flow through me to touch the lives of others.'
      ],
      prayer: 'Sacred Heart of Jesus, fill my heart with compassion for others. Amen.',
      reflection: 'How can I be more aware of the suffering around me and respond with Christ-like compassion?',
      scripture: 'When he saw the crowds, he had compassion for them, because they were harassed and helpless, like sheep without a shepherd. (Matthew 9:36)'
    },
    {
      day: 9,
      title: 'Day 9 - Generosity of the Sacred Heart',
      content: [
        'O Sacred Heart of Jesus, who gave everything for our salvation, even Your very life, teach me to be generous in my love and service. Help me to give freely of my time, talents, and resources for the good of others and the glory of God.',
        '',
        'Grant that I may never be selfish or stingy, but always ready to share what I have with those in need. Let my life be a reflection of Your own generous love, poured out without measure for all humanity.'
      ],
      prayer: 'Sacred Heart of Jesus, make my heart generous like Yours. Amen.',
      reflection: 'How can I be more generous in my daily life, sharing God\'s blessings with others?',
      scripture: 'Give, and it will be given to you; good measure, pressed down, shaken together, running over, will be put into your lap. (Luke 6:38)'
    }
  ],
  'st-joseph': [
    {
      day: 1,
      title: 'Day 1 - St. Joseph, Model of Faith',
      content: [
        'O glorious St. Joseph, faithful follower of Jesus Christ, to you do we raise our hearts and hands to implore your powerful intercession in obtaining from the benign Heart of Jesus all the helps and graces necessary for our spiritual and temporal welfare.',
        '',
        'You who were chosen by the Eternal Father to be the foster father of Jesus and the most chaste spouse of Mary, obtain for us a pure heart, a love of the interior life, and a faithful observance of our duties.'
      ],
      prayer: 'St. Joseph, model of faith, pray for us.',
      reflection: 'How can I grow in faith and trust in God\'s plan for my life, like St. Joseph did?',
      scripture: 'But as he considered these things, behold, an angel of the Lord appeared to him in a dream, saying, "Joseph, son of David, do not fear to take Mary as your wife." (Matthew 1:20)'
    },
    {
      day: 2,
      title: 'Day 2 - St. Joseph, Protector of the Holy Family',
      content: [
        'O most loving father St. Joseph, guardian of the Holy Family, protect our families as you protected Jesus and Mary. Watch over our homes and make them sanctuaries of peace, love, and virtue.',
        '',
        'Help us to follow your example of quiet devotion, faithful service, and complete trust in Divine Providence.'
      ],
      prayer: 'St. Joseph, protector of families, pray for us.',
      reflection: 'How can I better protect and nurture my family relationships, following St. Joseph\'s example?',
      scripture: 'And he rose and took the child and his mother by night and departed to Egypt. (Matthew 2:14)'
    },
    {
      day: 3,
      title: 'Day 3 - St. Joseph, Patron of Workers',
      content: [
        'O faithful St. Joseph, through your work as a carpenter you provided for the Holy Family and showed us the dignity of honest labor. Help us to see our work as a participation in God\'s creative activity.',
        '',
        'Grant that we may work with integrity, find meaning in our labor, and use our talents to serve God and neighbor.'
      ],
      prayer: 'St. Joseph, patron of workers, pray for us.',
      reflection: 'How can I offer my work as prayer and service to God and others?',
      scripture: 'Is not this the carpenter\'s son? Is not his mother called Mary? (Matthew 13:55)'
    },
    {
      day: 4,
      title: 'Day 4 - St. Joseph, Model of Obedience',
      content: [
        'O humble St. Joseph, you obeyed the voice of God\'s angel without question or delay. Teach us to listen for God\'s voice in our lives and to respond with prompt and generous obedience.',
        '',
        'Help us to surrender our own will to God\'s will, trusting that His plans are always for our good and His glory.'
      ],
      prayer: 'St. Joseph, model of obedience, pray for us.',
      reflection: 'How can I be more attentive to God\'s will and more ready to obey His guidance?',
      scripture: 'When Joseph woke from sleep, he did as the angel of the Lord commanded him. (Matthew 1:24)'
    },
    {
      day: 5,
      title: 'Day 5 - St. Joseph, Model of Humility',
      content: [
        'O humble St. Joseph, though you were chosen for the highest honor on earth, you remained hidden and sought no recognition. Teach us the beauty of humility and the joy of serving God in hiddenness.',
        '',
        'Help us to be content with doing our duty faithfully, whether others notice or not, seeking only to please God.'
      ],
      prayer: 'St. Joseph, model of humility, pray for us.',
      reflection: 'How can I serve God more humbly, without seeking recognition or praise?',
      scripture: 'But Mary kept all these things, pondering them in her heart. (Luke 2:19)'
    },
    {
      day: 6,
      title: 'Day 6 - St. Joseph, Model of Justice',
      content: [
        'O just St. Joseph, the Gospel calls you a "just man" because you lived according to God\'s law with perfect integrity. Help us to live justly in all our relationships and dealings.',
        '',
        'Grant us the wisdom to know what is right and the courage to do it, even when it is difficult or costly.'
      ],
      prayer: 'St. Joseph, model of justice, pray for us.',
      reflection: 'How can I live more justly and treat others with fairness and integrity?',
      scripture: 'And her husband Joseph, being a just man and unwilling to put her to shame, resolved to divorce her quietly. (Matthew 1:19)'
    },
    {
      day: 7,
      title: 'Day 7 - St. Joseph, Model of Purity',
      content: [
        'O most chaste St. Joseph, guardian of the Virgin of virgins, you lived in perfect purity of heart and body. Help us to live chastely according to our state in life.',
        '',
        'Purify our hearts and minds, and help us to see others as children of God, treating them with respect and dignity.'
      ],
      prayer: 'St. Joseph, model of purity, pray for us.',
      reflection: 'How can I guard my heart and live with greater purity in thought, word, and deed?',
      scripture: 'But he knew her not until she had given birth to a son. (Matthew 1:25)'
    },
    {
      day: 8,
      title: 'Day 8 - St. Joseph, Comfort of the Afflicted',
      content: [
        'O compassionate St. Joseph, you experienced the anxiety of not finding room at the inn, the fear of Herod\'s persecution, and the sorrow of losing the child Jesus. Comfort all who are afflicted and troubled.',
        '',
        'Help us to trust in God\'s providence during times of difficulty and to find peace in His love.'
      ],
      prayer: 'St. Joseph, comfort of the afflicted, pray for us.',
      reflection: 'How can I find comfort in God during times of trial and help comfort others who are suffering?',
      scripture: 'And his father and his mother marveled at what was said about him. (Luke 2:33)'
    },
    {
      day: 9,
      title: 'Day 9 - St. Joseph, Patron of a Happy Death',
      content: [
        'O blessed St. Joseph, who died peacefully in the arms of Jesus and Mary, be our guide and protector at the hour of our death. Help us to live each day in preparation for eternity.',
        '',
        'Grant us final perseverance and the grace to die in the friendship of God, surrounded by those we love.'
      ],
      prayer: 'St. Joseph, patron of a happy death, pray for us.',
      reflection: 'How can I live each day in readiness for eternity, following St. Joseph\'s example of faithful service?',
      scripture: 'And Jesus increased in wisdom and in stature and in favor with God and man. (Luke 2:52)'
    }
  ],
  'immaculate-heart': [
    {
      day: 1,
      title: 'Day 1 - The Immaculate Heart, Model of Love',
      content: [
        'O Immaculate Heart of Mary, overflowing with love for God and for all people, teach us to love as you loved. Your heart was always turned toward God, always ready to do His will with joy and generosity.',
        '',
        'Help us to love God above all things and to love our neighbor as ourselves. Purify our hearts so that our love may be genuine and selfless, like yours.'
      ],
      prayer: 'Immaculate Heart of Mary, teach us to love. Amen.',
      reflection: 'How can I grow in love for God and neighbor, following Mary\'s perfect example?',
      scripture: 'And Mary said, "My soul magnifies the Lord, and my spirit rejoices in God my Savior." (Luke 1:46-47)'
    },
    {
      day: 2,
      title: 'Day 2 - The Immaculate Heart, Model of Faith',
      content: [
        'O Immaculate Heart of Mary, perfect in faith, you believed the angel\'s word and trusted completely in God\'s plan, even when you could not understand. Your faith never wavered, even at the foot of the Cross.',
        '',
        'Strengthen our faith in times of doubt and difficulty. Help us to trust in God\'s goodness and wisdom, even when His ways are mysterious to us.'
      ],
      prayer: 'Immaculate Heart of Mary, increase our faith. Amen.',
      reflection: 'Where do I struggle with faith? How can I trust more deeply in God\'s plan for my life?',
      scripture: 'And Mary said, "Behold, I am the handmaid of the Lord; let it be to me according to your word." (Luke 1:38)'
    },
    {
      day: 3,
      title: 'Day 3 - The Immaculate Heart, Model of Hope',
      content: [
        'O Immaculate Heart of Mary, filled with hope even in the darkest hours, you never despaired but always trusted in God\'s promises. At the Cross, you hoped in the Resurrection; in the tomb, you hoped in eternal life.',
        '',
        'When we are tempted to despair, remind us that God is faithful to His promises. Fill our hearts with the hope that comes from knowing that nothing is impossible with God.'
      ],
      prayer: 'Immaculate Heart of Mary, fill us with hope. Amen.',
      reflection: 'How can I maintain hope during difficult times, trusting in God\'s faithfulness?',
      scripture: 'Blessed is she who believed that there would be a fulfillment of what was spoken to her from the Lord. (Luke 1:45)'
    },
    {
      day: 4,
      title: 'Day 4 - The Immaculate Heart, Model of Purity',
      content: [
        'O Immaculate Heart of Mary, pure and spotless from the first moment of your conception, you show us the beauty of a heart completely given to God. Your purity of heart allowed you to see God clearly.',
        '',
        'Purify our hearts from all sin and selfishness. Help us to seek what is pure, noble, and holy in all our thoughts, words, and actions.'
      ],
      prayer: 'Immaculate Heart of Mary, purify our hearts. Amen.',
      reflection: 'How can I cultivate greater purity of heart in my thoughts, desires, and actions?',
      scripture: 'Blessed are the pure in heart, for they shall see God. (Matthew 5:8)'
    },
    {
      day: 5,
      title: 'Day 5 - The Immaculate Heart, Model of Humility',
      content: [
        'O Immaculate Heart of Mary, humble handmaid of the Lord, though you were chosen for the highest honor, you considered yourself the lowliest of servants. Your humility made you worthy to be the Mother of God.',
        '',
        'Teach us true humility, which recognizes that all good comes from God. Help us to serve others without seeking recognition, following your example of hidden service.'
      ],
      prayer: 'Immaculate Heart of Mary, make us humble. Amen.',
      reflection: 'How can I grow in humility and serve others without seeking praise or recognition?',
      scripture: 'He has looked on the humble estate of his servant. For behold, from now on all generations will call me blessed. (Luke 1:48)'
    },
    {
      day: 6,
      title: 'Day 6 - The Immaculate Heart, Model of Obedience',
      content: [
        'O Immaculate Heart of Mary, perfectly obedient to God\'s will, you taught us that true freedom comes from saying "yes" to God. Your obedience brought salvation to the world.',
        '',
        'Help us to surrender our will to God\'s will, trusting that His plans are always for our good. Give us the grace to obey not just in great things, but in the small duties of daily life.'
      ],
      prayer: 'Immaculate Heart of Mary, teach us obedience. Amen.',
      reflection: 'How can I be more obedient to God\'s will in my daily choices and decisions?',
      scripture: 'And his mother said to the servants, "Do whatever he tells you." (John 2:5)'
    },
    {
      day: 7,
      title: 'Day 7 - The Immaculate Heart, Mother of Mercy',
      content: [
        'O Immaculate Heart of Mary, Mother of Mercy, you are our refuge in times of trouble and our comfort in sorrow. You intercede for us with maternal love, bringing our needs to your Son.',
        '',
        'Help us to show mercy to others as you show mercy to us. Teach us to forgive as we have been forgiven, and to be compassionate to all who suffer.'
      ],
      prayer: 'Immaculate Heart of Mary, be our Mother of Mercy. Amen.',
      reflection: 'How can I be more merciful and compassionate to others, especially those who have hurt me?',
      scripture: 'From now on all generations will call me blessed, for he who is mighty has done great things for me. (Luke 1:48-49)'
    },
    {
      day: 8,
      title: 'Day 8 - The Immaculate Heart, Queen of Peace',
      content: [
        'O Immaculate Heart of Mary, Queen of Peace, you bring the peace of Christ to our troubled world. Your heart, united to the Sacred Heart of Jesus, is a source of true peace for all who seek it.',
        '',
        'Help us to be peacemakers in our families, communities, and world. Grant us the peace that comes from knowing we are loved by God and called to love others.'
      ],
      prayer: 'Immaculate Heart of Mary, Queen of Peace, pray for us. Amen.',
      reflection: 'How can I be a better peacemaker in my relationships and community?',
      scripture: 'And suddenly there was with the angel a multitude of the heavenly host praising God and saying, "Glory to God in the highest, and on earth peace among those with whom he is pleased!" (Luke 2:13-14)'
    },
    {
      day: 9,
      title: 'Day 9 - The Immaculate Heart, Our Advocate',
      content: [
        'O Immaculate Heart of Mary, our loving advocate, you intercede for us before the throne of God. You present our prayers to Jesus with a mother\'s tenderness and care.',
        '',
        'Be our advocate now and at the hour of our death. Help us to persevere in grace and to reach our heavenly home where we will praise the Trinity forever with you.'
      ],
      prayer: 'Immaculate Heart of Mary, be our advocate. Amen.',
      reflection: 'How can I entrust my life more completely to Mary\'s maternal care and intercession?',
      scripture: 'But when the fullness of time had come, God sent forth his Son, born of woman. (Galatians 4:4)'
    }
  ],
  'st-therese': [
    {
      day: 1,
      title: 'Day 1 - Trust in God\'s Mercy',
      content: [
        'O Little Thérèse of the Child Jesus, please pick for me a rose from the heavenly gardens and send it to me as a message of love.',
        '',
        'You who spent your life seeking the "little way" of spiritual childhood, help me to trust in God\'s mercy as a child trusts in their father. Teach me to approach our Lord with confidence and simplicity.',
        '',
        'Intercede for me that I may have the grace to abandon myself completely to Divine Providence, knowing that God\'s love will provide for all my needs.'
      ],
      prayer: 'St. Thérèse, the Little Flower, pray for us that we may trust in God like little children.',
      reflection: 'How can I trust in God\'s mercy more completely today, approaching Him with childlike confidence?',
      scripture: 'Truly, I say to you, unless you turn and become like children, you will never enter the kingdom of heaven. (Matthew 18:3)'
    },
    {
      day: 2,
      title: 'Day 2 - Simplicity and Humility',
      content: [
        'Dear St. Thérèse, you discovered that the "little way" to holiness is through simplicity and humility. You wrote: "I will seek out a means of getting to Heaven by a little way - very short and very straight, a little way that is wholly new."',
        '',
        'Help me to embrace the simple and ordinary moments of life as opportunities for holiness. Teach me that I don\'t need to do great things to please God, but rather small things with great love.',
        '',
        'Intercede for me that I may find joy in the hidden life, serving God faithfully in the ordinary duties of each day.'
      ],
      prayer: 'St. Thérèse, teach us the little way of spiritual childhood.',
      reflection: 'How can I find holiness in the simple, ordinary moments of my daily life?',
      scripture: 'And whoever receives one such child in my name receives me. (Matthew 18:5)'
    },
    {
      day: 3,
      title: 'Day 3 - Love and Sacrifice',
      content: [
        'Sweet St. Thérèse, you understood that love is proven by sacrifice. You wrote: "Love proves itself by deeds, so how am I to show my love? Great deeds are forbidden me. The only way I can prove my love is by scattering flowers and these flowers are every little sacrifice, every glance and word, and the doing of the least actions for love."',
        '',
        'Help me to offer small sacrifices throughout the day as flowers of love for Jesus. Teach me to see every act of service, every moment of patience, every kind word as an opportunity to show my love for God.',
        '',
        'Intercede for me that I may transform even the smallest actions into acts of love through pure intention.'
      ],
      prayer: 'St. Thérèse, help us to scatter flowers of love through small sacrifices.',
      reflection: 'What small sacrifices can I offer today as flowers of love for Jesus?',
      scripture: 'And if I have prophetic powers, and understand all mysteries and all knowledge, and if I have all faith, so as to remove mountains, but have not love, I am nothing. (1 Corinthians 13:2)'
    },
    {
      day: 4,
      title: 'Day 4 - Confidence in Prayer',
      content: [
        'Beloved St. Thérèse, you had such confidence in prayer that you promised to spend your heaven doing good on earth, letting fall a shower of roses. You said: "I will spend my heaven in doing good on earth."',
        '',
        'Increase my confidence in prayer, knowing that God desires to answer our petitions for what is truly good for us. Help me to pray with the persistence and trust of a child asking their loving parent.',
        '',
        'Intercede for me that my prayers may be filled with trust and abandonment to God\'s will, whether He grants my requests or leads me in a different direction.'
      ],
      prayer: 'St. Thérèse, intercede for us with your shower of roses from heaven.',
      reflection: 'How can I pray with greater confidence and trust in God\'s loving response?',
      scripture: 'Ask, and it will be given to you; seek, and you will find; knock, and it will be opened to you. (Matthew 7:7)'
    },
    {
      day: 5,
      title: 'Day 5 - Suffering with Joy',
      content: [
        'Dear St. Thérèse, though you were young, you understood the value of suffering united to Christ\'s passion. You wrote: "I will suffer with joy, if I can, all that Jesus wills to send me."',
        '',
        'Help me to accept the crosses and difficulties of life with patience and even joy, knowing that they can be redemptive when united to Christ\'s suffering. Teach me to see suffering as an opportunity to show love for Jesus.',
        '',
        'Intercede for me that I may have the grace to say "yes" to whatever God permits in my life, trusting that He can bring good from all things.'
      ],
      prayer: 'St. Thérèse, help us to embrace our crosses with joy and love.',
      reflection: 'How can I unite my sufferings to Christ\'s passion and offer them for the salvation of souls?',
      scripture: 'Now I rejoice in my sufferings for your sake, and in my flesh I complete what is lacking in Christ\'s afflictions. (Colossians 1:24)'
    },
    {
      day: 6,
      title: 'Day 6 - Missionary Spirit',
      content: [
        'Zealous St. Thérèse, though you lived in a cloistered convent, your heart burned with missionary zeal. You adopted spiritual brothers who were priests and missionaries, supporting them with your prayers and sacrifices.',
        '',
        'Inspire in me a missionary heart that desires the salvation of all souls. Help me to understand that every prayer, every sacrifice, every act of love can contribute to the Church\'s mission of evangelization.',
        '',
        'Intercede for me that I may have a heart as wide as the world, praying and working for the conversion of sinners and the sanctification of priests.'
      ],
      prayer: 'St. Thérèse, patroness of missions, ignite our missionary zeal.',
      reflection: 'How can I participate in the Church\'s mission through prayer, sacrifice, and witness?',
      scripture: 'And he said to them, "Go into all the world and preach the gospel to the whole creation." (Mark 16:15)'
    },
    {
      day: 7,
      title: 'Day 7 - Devotion to the Holy Face',
      content: [
        'Loving St. Thérèse, you had a special devotion to the Holy Face of Jesus, taking the name "of the Holy Face" in religion. You saw in Christ\'s face, especially as it was during His passion, the mystery of God\'s love for humanity.',
        '',
        'Help me to contemplate the face of Jesus with love and compassion, seeing there the depths of God\'s mercy and love. Teach me to make reparation for the sins that continue to wound the Heart of Jesus.',
        '',
        'Intercede for me that I may see the face of Christ in every person I meet, especially in those who are suffering or marginalized.'
      ],
      prayer: 'St. Thérèse of the Holy Face, help us to contemplate Jesus with love.',
      reflection: 'How can I see the face of Christ in others, especially those who are difficult to love?',
      scripture: 'And we all, with unveiled face, beholding the glory of the Lord, are being changed into his likeness from one degree of glory to another. (2 Corinthians 3:18)'
    },
    {
      day: 8,
      title: 'Day 8 - Abandonment to Divine Mercy',
      content: [
        'Trusting St. Thérèse, you wrote: "What I understand by the flight of the eagle is the upward soaring of the soul towards God. My soul feels this longing for God." Your great secret was complete abandonment to God\'s merciful love.',
        '',
        'Teach me the art of spiritual abandonment, surrendering all my fears, anxieties, and desires into God\'s loving hands. Help me to believe deeply in His mercy and to trust that He will take care of everything.',
        '',
        'Intercede for me that I may abandon myself to Divine Mercy with the same confidence you showed, knowing that God\'s love will never disappoint those who trust in Him.'
      ],
      prayer: 'St. Thérèse, teach us perfect abandonment to Divine Mercy.',
      reflection: 'What fears or worries do I need to surrender more completely to God\'s mercy?',
      scripture: 'Therefore do not be anxious about tomorrow, for tomorrow will be anxious for itself. Sufficient for the day is its own trouble. (Matthew 6:34)'
    },
    {
      day: 9,
      title: 'Day 9 - The Shower of Roses',
      content: [
        'Dear St. Thérèse, you promised: "After my death, I will let fall a shower of roses. I will spend my heaven doing good on earth." You continue to intercede for us from your place in heaven.',
        '',
        'As we conclude this novena, we ask for your powerful intercession for all our needs, especially [mention your intentions here]. Send us your promised shower of roses as signs of your prayer and God\'s love.',
        '',
        'Help us to continue living the "little way" you taught us, growing in trust, simplicity, and love until we join you in heaven to praise God forever.'
      ],
      prayer: 'St. Thérèse, let fall upon us your promised shower of roses.',
      reflection: 'How will I continue to live the "little way" of spiritual childhood in my daily life?',
      scripture: 'Come to me, all who labor and are heavy laden, and I will give you rest. Take my yoke upon you, and learn from me; for I am gentle and lowly in heart, and you will find rest for your souls. (Matthew 11:28-29)'
    }
  ],
  'st-jude': [
    {
      day: 1,
      title: 'Day 1 - Hope in Desperate Situations',
      content: [
        'O most holy apostle, St. Jude, faithful servant and friend of Jesus, the Church honors and invokes you universally as the patron of hopeless cases, of things almost despaired of.',
        '',
        'Pray for me, I am so helpless and alone. Intercede with God for me that He bring visible and speedy help where help is almost despaired of. Come to my assistance in this great need that I may receive the consolation and help of heaven in all my necessities, tribulations, and sufferings.',
        '',
        'Help me to remember that no situation is truly hopeless when we turn to God with faith and trust in His providence.'
      ],
      prayer: 'St. Jude, patron of hopeless cases, pray for us who have recourse to you.',
      reflection: 'What situation in my life seems hopeless? How can I surrender it to God with greater trust?',
      scripture: 'Is anything too hard for the Lord? (Genesis 18:14)'
    },
    {
      day: 2,
      title: 'Day 2 - Faith in God\'s Providence',
      content: [
        'Glorious St. Jude, you who were chosen by Jesus to be one of His twelve apostles, increase my faith in God\'s providence. Help me to trust that God has a plan for my life, even when I cannot see the way forward.',
        '',
        'Intercede for me that I may have unwavering faith in God\'s goodness, even in times of trial and uncertainty. Teach me to see every difficulty as an opportunity to grow in trust and dependence on the Lord.',
        '',
        'Help me to remember that God\'s ways are not our ways, and His thoughts are higher than our thoughts.'
      ],
      prayer: 'St. Jude, apostle of faith, strengthen our trust in God\'s providence.',
      reflection: 'How can I grow in faith and trust, especially when God\'s plan is unclear to me?',
      scripture: 'For my thoughts are not your thoughts, neither are your ways my ways, declares the Lord. (Isaiah 55:8)'
    },
    {
      day: 3,
      title: 'Day 3 - Perseverance in Prayer',
      content: [
        'Faithful St. Jude, you who remained loyal to Christ even unto death, teach me perseverance in prayer. Help me to continue praying even when my prayers seem unanswered or when I am tempted to give up.',
        '',
        'Intercede for me that I may have the grace to pray with persistence and patience, knowing that God hears every prayer and answers in His own perfect time and way.',
        '',
        'Strengthen my resolve to keep praying for those intentions that seem impossible, trusting in the power of persistent prayer.'
      ],
      prayer: 'St. Jude, help us to persevere in prayer with unwavering hope.',
      reflection: 'For what intentions do I need to pray with greater persistence and patience?',
      scripture: 'And he told them a parable to the effect that they ought always to pray and not lose heart. (Luke 18:1)'
    },
    {
      day: 4,
      title: 'Day 4 - Strength in Suffering',
      content: [
        'Courageous St. Jude, you who witnessed Christ\'s passion and understood the redemptive power of suffering, help me to find strength in my own trials and sufferings.',
        '',
        'Intercede for me that I may unite my sufferings to those of Christ, offering them for the salvation of souls and my own purification. Help me to see that suffering, when accepted with faith, can be a source of grace.',
        '',
        'Grant me the courage to face my difficulties with patience and the wisdom to learn from every trial.'
      ],
      prayer: 'St. Jude, give us strength to bear our crosses with faith and hope.',
      reflection: 'How can I unite my sufferings to Christ\'s passion and find meaning in my trials?',
      scripture: 'Now I rejoice in my sufferings for your sake, and in my flesh I complete what is lacking in Christ\'s afflictions. (Colossians 1:24)'
    },
    {
      day: 5,
      title: 'Day 5 - Help for the Desperate',
      content: [
        'Compassionate St. Jude, you who are known as the saint of desperate cases and lost causes, look with mercy upon all who are in desperate need. Your intercession has brought hope to countless souls in their darkest hours.',
        '',
        'I place my desperate situation before you, trusting in your powerful intercession. Help me to find solutions where none seem possible, and to discover hope where despair threatens to overwhelm me.',
        '',
        'Intercede especially for all those who have no one else to turn to, that they may find in you a faithful advocate and friend.'
      ],
      prayer: 'St. Jude, helper of the desperate, intercede for all who have lost hope.',
      reflection: 'How can I be a source of hope for others who are struggling with desperate situations?',
      scripture: 'The Lord is near to the brokenhearted and saves the crushed in spirit. (Psalm 34:18)'
    },
    {
      day: 6,
      title: 'Day 6 - Courage to Witness',
      content: [
        'Brave St. Jude, you who preached the Gospel fearlessly despite persecution and opposition, give me courage to witness to my faith. Help me to speak the truth with love, even when it is difficult or unpopular.',
        '',
        'Intercede for me that I may have the courage to live my faith authentically, serving as a light in the darkness for those around me. Help me to be bold in proclaiming God\'s love and mercy.',
        '',
        'Grant me the wisdom to know when to speak and when to remain silent, always acting out of love for God and neighbor.'
      ],
      prayer: 'St. Jude, give us courage to witness to our faith with boldness and love.',
      reflection: 'How can I be a better witness to my faith in my daily life and relationships?',
      scripture: 'But you will receive power when the Holy Spirit has come upon you, and you will be my witnesses. (Acts 1:8)'
    },
    {
      day: 7,
      title: 'Day 7 - Devotion to Jesus Christ',
      content: [
        'Devoted St. Jude, you who loved Jesus with all your heart and followed Him faithfully to the end, deepen my love for our Lord. Help me to know Jesus more intimately and to love Him more ardently.',
        '',
        'Intercede for me that I may grow in devotion to the Sacred Heart of Jesus, finding in His love the strength and consolation I need for my journey. Help me to make Jesus the center of my life.',
        '',
        'Grant me the grace to imitate your loyalty and dedication, never turning away from Christ no matter what difficulties I may face.'
      ],
      prayer: 'St. Jude, increase our love and devotion to Jesus Christ.',
      reflection: 'How can I deepen my relationship with Jesus and make Him more central to my life?',
      scripture: 'As the Father has loved me, so have I loved you. Abide in my love. (John 15:9)'
    },
    {
      day: 8,
      title: 'Day 8 - Intercession for Others',
      content: [
        'Charitable St. Jude, you who continue to intercede from heaven for all who call upon you, teach me to pray for others with the same compassion you show. Help me to be generous in my prayers for those in need.',
        '',
        'Intercede for me that I may have a heart like yours, always ready to help those who are suffering or in distress. Help me to see prayer as a powerful way to serve my neighbor.',
        '',
        'Grant me the grace to remember in prayer all those who have no one to pray for them, especially the forgotten and abandoned.'
      ],
      prayer: 'St. Jude, teach us to intercede for others with compassionate hearts.',
      reflection: 'Who in my life needs my prayers most urgently? How can I be more faithful in praying for others?',
      scripture: 'I urge that supplications, prayers, intercessions, and thanksgivings be made for all people. (1 Timothy 2:1)'
    },
    {
      day: 9,
      title: 'Day 9 - Gratitude and Trust',
      content: [
        'Glorious St. Jude, as we conclude this novena, we thank you for your powerful intercession and your example of faithfulness. Help us to live with grateful hearts, recognizing God\'s blessings even in difficult times.',
        '',
        'We entrust to your care all our intentions, especially those that seem impossible or hopeless. Continue to intercede for us that we may grow in faith, hope, and love.',
        '',
        'Grant us the grace to trust completely in God\'s providence, knowing that He will provide for all our needs according to His perfect will. May we never cease to hope in His mercy and love.'
      ],
      prayer: 'St. Jude, we thank you for your intercession and trust in your continued prayers for us.',
      reflection: 'How can I live with greater gratitude and continue to grow in hope and trust?',
      scripture: 'May the God of hope fill you with all joy and peace in believing, so that by the power of the Holy Spirit you may abound in hope. (Romans 15:13)'
    }
  ],
  'st-anthony': [
    {
      day: 1,
      title: 'Day 1 - Finding What is Lost',
      content: [
        'O wonderful St. Anthony, glorious on account of the fame of your miracles, and through the condescension of Jesus in coming in the form of a little child to rest in your arms, obtain for me of His bounty the grace I yearn for so ardently.',
        '',
        'You who were so successful in finding lost and stolen things, help me to find what I have lost - not just material possessions, but perhaps my way in life, my peace of mind, or my fervor in faith.',
        '',
        'Intercede for me that I may recover what is truly important and that I may always trust in God\'s providence, knowing that He knows what I need before I ask.'
      ],
      prayer: 'St. Anthony, finder of lost things, help us to seek and find what is truly important.',
      reflection: 'What have I lost in my spiritual life that I need St. Anthony\'s help to recover?',
      scripture: 'What woman, having ten silver coins, if she loses one coin, does not light a lamp and sweep the house and seek diligently until she finds it? (Luke 15:8)'
    },
    {
      day: 2,
      title: 'Day 2 - Devotion to the Child Jesus',
      content: [
        'Blessed St. Anthony, you who experienced the wonderful privilege of holding the Child Jesus in your arms, help me to grow in love and devotion to our Lord. Your vision of the Christ Child reminds us of the humility and simplicity of God\'s love.',
        '',
        'Teach me to approach Jesus with childlike trust and wonder. Help me to see Him not as distant and unreachable, but as close and accessible, desiring to dwell in my heart as He did in your arms.',
        '',
        'Intercede for me that I may cultivate a tender devotion to Jesus, especially as He is present in the Blessed Sacrament.'
      ],
      prayer: 'St. Anthony, help us to embrace the Child Jesus with love and devotion.',
      reflection: 'How can I approach Jesus with greater childlike trust and simplicity?',
      scripture: 'And he took a child and put him in the midst of them, and taking him in his arms, he said to them, "Whoever receives one such child in my name receives me." (Mark 9:36-37)'
    },
    {
      day: 3,
      title: 'Day 3 - Wisdom and Preaching',
      content: [
        'Eloquent St. Anthony, Doctor of the Church, you who preached with such wisdom and power that even the fish came to listen when people would not, grant me wisdom in my words and actions.',
        '',
        'Help me to speak truth with love and to share the Gospel through my life as well as my words. Give me the courage to proclaim God\'s message when needed and the wisdom to know when silence is more appropriate.',
        '',
        'Intercede for me that my life may be a sermon of love, drawing others closer to God through the example of Christian living.'
      ],
      prayer: 'St. Anthony, Doctor of the Church, grant us wisdom in word and deed.',
      reflection: 'How can I better proclaim the Gospel through my words and actions?',
      scripture: 'And they were astonished at his teaching, for his word possessed authority. (Luke 4:32)'
    },
    {
      day: 4,
      title: 'Day 4 - Poverty and Simplicity',
      content: [
        'Poor St. Anthony, you who embraced the Franciscan life of poverty and simplicity, teach me to value spiritual riches over material possessions. Help me to find contentment in what I have and to share generously with those in need.',
        '',
        'Free me from excessive attachment to worldly things that can distract me from seeking first the kingdom of God. Help me to see that true wealth consists in loving and being loved by God.',
        '',
        'Intercede for me that I may live simply and humbly, finding joy in the essential things of life and in service to others.'
      ],
      prayer: 'St. Anthony, teach us the joy of simplicity and spiritual poverty.',
      reflection: 'What material attachments do I need to let go of to grow in spiritual freedom?',
      scripture: 'Blessed are the poor in spirit, for theirs is the kingdom of heaven. (Matthew 5:3)'
    },
    {
      day: 5,
      title: 'Day 5 - Humility and Obedience',
      content: [
        'Humble St. Anthony, you who submitted yourself obediently to God\'s will and to your superiors, teach me true humility. Help me to recognize that all good comes from God and that I am called to serve, not to be served.',
        '',
        'Grant me the grace to accept correction with humility and to obey God\'s commandments with a willing heart. Help me to see obedience not as restriction but as freedom to do God\'s will.',
        '',
        'Intercede for me that I may follow your example of humble service, seeking to please God rather than seeking human praise.'
      ],
      prayer: 'St. Anthony, model of humility, teach us to serve God with humble hearts.',
      reflection: 'How can I grow in humility and obedience to God\'s will in my daily life?',
      scripture: 'Take my yoke upon you, and learn from me, for I am gentle and humble in heart. (Matthew 11:29)'
    },
    {
      day: 6,
      title: 'Day 6 - Miraculous Power',
      content: [
        'Miraculous St. Anthony, through your intercession God has worked countless wonders for those who call upon you with faith. Your miracles continue to bring hope to the afflicted and strengthen the faith of believers.',
        '',
        'I place before you my needs and the needs of those I love, trusting in your powerful intercession. Help me to have faith that God can work miracles in my life when it is according to His will.',
        '',
        'Intercede for me that I may be open to God\'s miraculous grace working in ordinary ways, and that I may recognize His blessings even when they come in unexpected forms.'
      ],
      prayer: 'St. Anthony, worker of miracles, intercede for us in our needs.',
      reflection: 'What miracle do I need in my life, and how can I trust more deeply in God\'s power?',
      scripture: 'And Jesus answered them, "Truly, I say to you, if you have faith and do not doubt... nothing will be impossible for you." (Matthew 21:21)'
    },
    {
      day: 7,
      title: 'Day 7 - Love for the Poor',
      content: [
        'Charitable St. Anthony, you who had great love for the poor and marginalized, open my heart to see Christ in those who are suffering. Help me to respond to the needs of others with generous compassion.',
        '',
        'Teach me to give not just from my abundance but from my substance, sharing what I have with those who have less. Help me to see that in serving the poor, I am serving Christ Himself.',
        '',
        'Intercede for me that I may have eyes to see the needy around me and a heart that moves me to action on their behalf.'
      ],
      prayer: 'St. Anthony, friend of the poor, inspire us to serve those in need.',
      reflection: 'How can I better serve the poor and marginalized in my community?',
      scripture: 'Truly, I say to you, as you did it to one of the least of these my brothers, you did it to me. (Matthew 25:40)'
    },
    {
      day: 8,
      title: 'Day 8 - Zeal for Souls',
      content: [
        'Zealous St. Anthony, you who labored tirelessly for the salvation of souls, inspire in me a similar passion for bringing others to know and love God. Help me to see every person as precious in God\'s sight.',
        '',
        'Grant me the wisdom to know how to share my faith appropriately and the courage to live in such a way that others are drawn to Christ through my example.',
        '',
        'Intercede for me that I may be an instrument of God\'s grace in the lives of others, helping to lead them to eternal salvation through prayer, witness, and loving service.'
      ],
      prayer: 'St. Anthony, zealous apostle, inspire us to work for the salvation of souls.',
      reflection: 'How can I be more effective in sharing God\'s love and drawing others to faith?',
      scripture: 'And he said to them, "Go into all the world and proclaim the gospel to the whole creation." (Mark 16:15)'
    },
    {
      day: 9,
      title: 'Day 9 - Eternal Glory',
      content: [
        'Glorious St. Anthony, you who now enjoy the beatific vision and the eternal joy of heaven, help us to keep our eyes fixed on our eternal destination. Remind us that this life is a pilgrimage toward our true home with God.',
        '',
        'As we conclude this novena, we entrust to your intercession all our petitions, especially those we hold most dear in our hearts. Help us to trust in God\'s perfect will, knowing that He desires our ultimate happiness.',
        '',
        'Intercede for us that we may persevere in faith until the end of our lives and join you in the eternal praise of the Trinity. May your example inspire us to live lives worthy of our calling as children of God.'
      ],
      prayer: 'St. Anthony, guide us on our journey to eternal life with God.',
      reflection: 'How can I live each day with eternity in mind, preparing for my eternal home?',
      scripture: 'For here we have no lasting city, but we seek the city that is to come. (Hebrews 13:14)'
    }
  ],
  'blessed-mother': [
    {
      day: 1,
      title: 'Day 1 - Mary, Mother of God',
      content: [
        'Hail Mary, Mother of God, Queen of Heaven and Earth! We honor you as the Mother of our Lord Jesus Christ and our spiritual mother. You who were chosen from all eternity to be the Mother of the Savior, pray for us your children.',
        '',
        'Help us to understand the great dignity that God has given to you and through you to all humanity. Teach us to honor you as our mother while always glorifying your Son, Jesus.',
        '',
        'Intercede for us that we may grow in appreciation for the mystery of the Incarnation and the role you played in our salvation.'
      ],
      prayer: 'Hail Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen.',
      reflection: 'How can I honor Mary as my spiritual mother while keeping Jesus at the center of my devotion?',
      scripture: 'And the angel said to her, "Do not be afraid, Mary, for you have found favor with God. And behold, you will conceive in your womb and bear a son, and you shall call his name Jesus." (Luke 1:30-31)'
    },
    {
      day: 2,
      title: 'Day 2 - Mary\'s Faith and Trust',
      content: [
        'Blessed Mary, woman of faith, you believed the angel\'s word even when it seemed impossible. Your "yes" to God changed the course of human history and opened the way for our salvation.',
        '',
        'Teach us to have faith like yours - unwavering trust in God\'s promises even when we cannot understand His plan. Help us to say "yes" to God\'s will in our own lives with the same generous heart.',
        '',
        'Intercede for us that our faith may be strong in times of trial and that we may always trust in God\'s loving providence.'
      ],
      prayer: 'Mary, woman of faith, increase our trust in God\'s promises.',
      reflection: 'What is God asking of me that requires greater faith and trust? How can I say "yes" like Mary?',
      scripture: 'And Mary said, "Behold, I am the handmaid of the Lord; let it be to me according to your word." (Luke 1:38)'
    },
    {
      day: 3,
      title: 'Day 3 - Mary\'s Joy and Praise',
      content: [
        'Joyful Mary, you who proclaimed the Magnificat with a heart full of praise for God\'s goodness, teach us to recognize God\'s blessings in our lives and to respond with grateful hearts.',
        '',
        'Help us to find joy even in difficult circumstances, knowing that God is working all things for our good. Teach us to praise God not just when things go well, but in all seasons of life.',
        '',
        'Intercede for us that we may have hearts like yours, always ready to magnify the Lord and rejoice in God our Savior.'
      ],
      prayer: 'Mary, cause of our joy, teach us to praise God with grateful hearts.',
      reflection: 'How can I cultivate a spirit of joy and gratitude like Mary\'s, especially during challenging times?',
      scripture: 'And Mary said, "My soul magnifies the Lord, and my spirit rejoices in God my Savior." (Luke 1:46-47)'
    },
    {
      day: 4,
      title: 'Day 4 - Mary at the Nativity',
      content: [
        'Tender Mary, you who gave birth to our Savior in the humble stable of Bethlehem, help us to find God in the simple and ordinary moments of life. You welcomed the shepherds and treasured the angel\'s message in your heart.',
        '',
        'Teach us to be like you - pondering God\'s works in our hearts and finding wonder in His presence among us. Help us to welcome Christ into our lives with the same love and care you showed.',
        '',
        'Intercede for us that we may recognize Christ\'s presence in our daily lives and respond with open and loving hearts.'
      ],
      prayer: 'Mary, Mother of the Word made flesh, help us to welcome Jesus into our hearts.',
      reflection: 'How can I better recognize and welcome Christ\'s presence in the ordinary moments of my life?',
      scripture: 'But Mary treasured up all these things, pondering them in her heart. (Luke 2:19)'
    },
    {
      day: 5,
      title: 'Day 5 - Mary at the Cross',
      content: [
        'Sorrowful Mary, you who stood beneath the cross watching your Son suffer and die for our sins, teach us how to unite our sufferings to His. Your heart was pierced with sorrow, yet you remained faithful to the end.',
        '',
        'Help us to see that suffering, when accepted with faith, can be redemptive. Teach us to stand by our loved ones in their trials just as you stood by Jesus in His passion.',
        '',
        'Intercede for us that we may have courage in times of suffering and that our pain may be united to Christ\'s for the salvation of souls.'
      ],
      prayer: 'Mary, Mother of Sorrows, help us to unite our sufferings to those of Jesus.',
      reflection: 'How can I unite my sufferings to Christ\'s passion and support others who are suffering?',
      scripture: 'When Jesus saw his mother and the disciple whom he loved standing nearby, he said to his mother, "Woman, behold, your son!" (John 19:26)'
    },
    {
      day: 6,
      title: 'Day 6 - Mary, Mother of the Church',
      content: [
        'Loving Mary, after Jesus entrusted you to John and John to you, you became the mother of all believers. You were present with the apostles at Pentecost, supporting the infant Church with your prayers.',
        '',
        'Be our mother too, guiding us in our journey of faith. Help us to be faithful members of the Church, supporting one another in love and growing together in holiness.',
        '',
        'Intercede for us that the Church may be strong and united, and that all Christians may work together for the spread of the Gospel.'
      ],
      prayer: 'Mary, Mother of the Church, guide us in our life of faith.',
      reflection: 'How can I be a better member of the Church community and support my fellow believers?',
      scripture: 'All these with one accord were devoting themselves to prayer, together with the women and Mary the mother of Jesus, and his brothers. (Acts 1:14)'
    },
    {
      day: 7,
      title: 'Day 7 - Mary, Our Intercessor',
      content: [
        'Compassionate Mary, you who noticed the wine had run out at the wedding in Cana and brought the need to Jesus, continue to intercede for us in all our necessities. You know what we need before we ask.',
        '',
        'Bring our prayers to your Son and ask Him to provide for our spiritual and temporal needs. Help us to trust that you will always lead us to Jesus and that He will listen to your motherly intercession.',
        '',
        'Intercede for us in all our needs, especially those we carry most deeply in our hearts.'
      ],
      prayer: 'Mary, our Mother and Intercessor, bring our needs to Jesus.',
      reflection: 'What needs do I want to entrust to Mary\'s intercession? How can she help me draw closer to Jesus?',
      scripture: 'His mother said to the servants, "Do whatever he tells you." (John 2:5)'
    },
    {
      day: 8,
      title: 'Day 8 - Mary, Queen of Peace',
      content: [
        'Peaceful Mary, Queen of Peace, you who bring the peace of Christ to troubled hearts and to our troubled world, help us to be peacemakers in our families and communities.',
        '',
        'Teach us to forgive those who have hurt us and to seek reconciliation where there is division. Help us to approach conflicts with your gentleness and wisdom.',
        '',
        'Intercede for peace in our world, that nations may live in harmony and that the Prince of Peace may reign in every heart.'
      ],
      prayer: 'Mary, Queen of Peace, bring Christ\'s peace to our hearts and our world.',
      reflection: 'How can I be a better peacemaker in my relationships and community? Where do I need to forgive?',
      scripture: 'Blessed are the peacemakers, for they shall be called sons of God. (Matthew 5:9)'
    },
    {
      day: 9,
      title: 'Day 9 - Mary, Our Hope of Heaven',
      content: [
        'Glorious Mary, you who were assumed body and soul into heaven, you are our hope and our model of what awaits all the faithful. You show us that death is not the end but the beginning of eternal life with God.',
        '',
        'Help us to live each day with heaven as our goal, making choices that draw us closer to eternal life. Intercede for us at the hour of our death that we may die in friendship with God.',
        '',
        'As we conclude this novena, we entrust all our intentions to your maternal care. Continue to watch over us and guide us until we join you in the eternal kingdom of your Son.'
      ],
      prayer: 'Mary, assumed into heaven, guide us on our journey to eternal life.',
      reflection: 'How can I live each day with eternity in mind? What do I need to change to grow in holiness?',
      scripture: 'And a great sign appeared in heaven: a woman clothed with the sun, with the moon under her feet, and on her head a crown of twelve stars. (Revelation 12:1)'
    }
  ],
  'holy-spirit': [
    {
      day: 1,
      title: 'Day 1 - Come, Holy Spirit',
      content: [
        'Come, Holy Spirit, fill the hearts of Your faithful and kindle in them the fire of Your love. Send forth Your Spirit and they shall be created, and You shall renew the face of the earth.',
        '',
        'Divine Spirit, Third Person of the Blessed Trinity, we invoke Your presence in our lives. You who proceeded from the Father and the Son, come to dwell within us and transform us by Your grace.',
        '',
        'We ask for the grace to be open to Your inspirations and to follow Your guidance in all things. Help us to recognize Your presence in our daily lives and to respond with faith and obedience.'
      ],
      prayer: 'Come, Holy Spirit, Creator blest, and in our hearts take up Your rest.',
      reflection: 'How can I be more open to the Holy Spirit\'s presence and guidance in my daily life?',
      scripture: 'And I will ask the Father, and he will give you another Helper, to be with you forever. (John 14:16)'
    },
    {
      day: 2,
      title: 'Day 2 - The Gift of Wisdom',
      content: [
        'Holy Spirit, source of all wisdom, grant us the gift of wisdom that we may see all things in the light of eternity. Help us to understand the deeper meaning of life and to make decisions that lead us closer to God.',
        '',
        'This gift enables us to judge all things according to divine truth and to see creation as God sees it. Give us wisdom to discern between good and evil, truth and falsehood.',
        '',
        'Help us to seek first the kingdom of God, knowing that all other things will be added unto us according to our need.'
      ],
      prayer: 'Holy Spirit, grant us the gift of wisdom to see all things in Your light.',
      reflection: 'How can I seek God\'s wisdom in the decisions I need to make? What situations need divine insight?',
      scripture: 'If any of you lacks wisdom, let him ask God, who gives generously to all without reproach, and it will be given him. (James 1:5)'
    },
    {
      day: 3,
      title: 'Day 3 - The Gift of Understanding',
      content: [
        'Holy Spirit, giver of understanding, illuminate our minds that we may comprehend the truths of faith more deeply. Help us to understand not just with our intellect but with our hearts the mysteries of God.',
        '',
        'Grant us the ability to see beyond the surface of things to their spiritual significance. Help us to understand the Scriptures, the teachings of the Church, and the workings of divine grace in our lives.',
        '',
        'Give us understanding hearts that can empathize with others and see Christ in every person we encounter.'
      ],
      prayer: 'Holy Spirit, grant us understanding to comprehend Your truth and love.',
      reflection: 'What aspects of my faith do I need greater understanding of? How can I grow in empathy for others?',
      scripture: 'Then he opened their minds to understand the Scriptures. (Luke 24:45)'
    },
    {
      day: 4,
      title: 'Day 4 - The Gift of Counsel',
      content: [
        'Holy Spirit, divine counselor, guide us in our choices and decisions. When we face difficult situations or moral dilemmas, be our guide and show us the right path to take.',
        '',
        'Help us to seek good advice from wise and holy people, but ultimately to rely on Your guidance. Give us the ability to counsel others with wisdom and compassion when they turn to us for help.',
        '',
        'Grant us the grace to pause and pray before making important decisions, always seeking to do what pleases God.'
      ],
      prayer: 'Holy Spirit, our Counselor, guide us in all our decisions and choices.',
      reflection: 'What decisions do I need divine guidance for? How can I be a better counselor to others who seek my advice?',
      scripture: 'But the Helper, the Holy Spirit, whom the Father will send in my name, he will teach you all things. (John 14:26)'
    },
    {
      day: 5,
      title: 'Day 5 - The Gift of Fortitude',
      content: [
        'Holy Spirit, source of strength, grant us the gift of fortitude to persevere in doing good even when it is difficult. Give us courage to stand up for what is right and to remain faithful to our convictions.',
        '',
        'Strengthen us in times of trial, suffering, and persecution. Help us to bear our crosses with patience and to support others who are struggling with their burdens.',
        '',
        'Grant us the spiritual strength to resist temptation and to choose the narrow path that leads to eternal life, even when the wide road seems more appealing.'
      ],
      prayer: 'Holy Spirit, grant us fortitude to persevere in doing good despite all difficulties.',
      reflection: 'Where do I need greater courage and strength in my spiritual life? How can I support others who are struggling?',
      scripture: 'But you will receive power when the Holy Spirit has come upon you. (Acts 1:8)'
    },
    {
      day: 6,
      title: 'Day 6 - The Gift of Knowledge',
      content: [
        'Holy Spirit, teacher of truth, grant us the gift of knowledge that we may know ourselves as God knows us and see creation as it truly is in relation to God.',
        '',
        'Help us to distinguish between what is eternal and what is temporary, what is essential and what is superficial. Give us knowledge of our own strengths and weaknesses so that we may grow in humility and self-understanding.',
        '',
        'Grant us the knowledge to recognize God\'s hand in all the events of our lives, both joyful and sorrowful, and to learn from every experience.'
      ],
      prayer: 'Holy Spirit, grant us true knowledge of ourselves and of Your ways.',
      reflection: 'What do I need to know better about myself and my relationship with God? How can I see His hand in my life?',
      scripture: 'And this is eternal life, that they know you, the only true God, and Jesus Christ whom you have sent. (John 17:3)'
    },
    {
      day: 7,
      title: 'Day 7 - The Gift of Piety',
      content: [
        'Holy Spirit, source of all devotion, grant us the gift of piety that we may worship God with reverence and love. Help us to approach prayer, Mass, and the sacraments with hearts full of faith and devotion.',
        '',
        'Increase our love for God and our desire to spend time in His presence. Help us to find joy in prayer, in reading Scripture, and in all the spiritual practices that draw us closer to You.',
        '',
        'Grant us piety that extends to our relationships with others, treating all people with the respect due to children of God.'
      ],
      prayer: 'Holy Spirit, fill us with piety and devotion in our worship and service.',
      reflection: 'How can I approach prayer and worship with greater reverence and love? How can I show greater respect for others?',
      scripture: 'But the hour is coming, and is now here, when the true worshipers will worship the Father in spirit and truth. (John 4:23)'
    },
    {
      day: 8,
      title: 'Day 8 - The Gift of Fear of the Lord',
      content: [
        'Holy Spirit, source of holy fear, grant us the gift of fear of the Lord - not a servile fear, but a reverent awe and wonder at God\'s majesty and holiness. Help us to understand our place as creatures before our Creator.',
        '',
        'This gift helps us to avoid sin not just because of punishment, but because sin offends our loving God. Give us a deep appreciation for God\'s holiness and our call to be holy as He is holy.',
        '',
        'Help us to live with reverence and gratitude, always mindful that we are in the presence of the all-holy God who loves us beyond measure.'
      ],
      prayer: 'Holy Spirit, grant us holy fear and reverent awe before God\'s majesty.',
      reflection: 'How can I cultivate greater reverence for God\'s holiness? What helps me avoid sin out of love rather than fear?',
      scripture: 'The fear of the Lord is the beginning of wisdom, and the knowledge of the Holy One is insight. (Proverbs 9:10)'
    },
    {
      day: 9,
      title: 'Day 9 - The Fruits of the Spirit',
      content: [
        'Holy Spirit, as we conclude this novena, we ask that You produce in us the fruits of Your presence: love, joy, peace, patience, kindness, goodness, faithfulness, gentleness, and self-control.',
        '',
        'Transform our lives so that others may see Christ in us through these fruits. Help us to be instruments of Your peace and love in our families, communities, and world.',
        '',
        'We entrust all our intentions to Your care, asking that You continue to guide, protect, and sanctify us. Come, Holy Spirit, and renew the face of the earth, beginning with our own hearts.'
      ],
      prayer: 'Come, Holy Spirit, fill us with Your gifts and produce in us the fruits of holiness.',
      reflection: 'Which fruits of the Spirit do I need to cultivate more in my life? How can I be a better witness to others?',
      scripture: 'But the fruit of the Spirit is love, joy, peace, patience, kindness, goodness, faithfulness, gentleness, self-control. (Galatians 5:22-23)'
    }
  ],
  'our-lady-of-confidence': [
    {
      day: 1,
      title: 'Day 1 - Protection from Disease',
      content: [
        'O Mary, Our Lady of Confidence, we thank God for giving you to us as our powerful intercessor. Through your maternal care, the seminarians of St. Mary\'s Seminary were protected during the Asiatic flu outbreak of 1837.',
        '',
        'We ask you to protect us and all people from the dangers of disease. In times of illness and epidemic, be our refuge and our hope. Help us to trust in God\'s providence even when we are afraid.',
        '',
        'Present our needs to your Divine Son, and obtain for us the graces we need for body and soul.'
      ],
      prayer: 'Our Lady of Confidence, pray for us that we may trust completely in God\'s protection.',
      reflection: 'How can I grow in trust during times of uncertainty about my health or the health of loved ones?',
      scripture: 'The Lord is my light and my salvation; whom shall I fear? The Lord is the stronghold of my life; of whom shall I be afraid? (Psalm 27:1)'
    },
    {
      day: 2,
      title: 'Day 2 - Protection from War',
      content: [
        'O Mary, Our Lady of Confidence, during World War I, over 100 seminarians placed themselves under your protection, and all returned home safely. Your maternal intercession proved powerful in the midst of great danger.',
        '',
        'We ask you to protect us and all people from the dangers of war. Intercede for peace in our world, in our nations, in our communities, and in our hearts. Help leaders to choose dialogue over violence.',
        '',
        'Grant us the courage to be peacemakers in our own lives, following the example of your Son, the Prince of Peace.'
      ],
      prayer: 'Our Lady of Confidence, Queen of Peace, obtain for us true and lasting peace.',
      reflection: 'How can I be an instrument of peace in my relationships and community?',
      scripture: 'Blessed are the peacemakers, for they shall be called sons of God. (Matthew 5:9)'
    },
    {
      day: 3,
      title: 'Day 3 - Intercession for Seminarians',
      content: [
        'O Mary, Our Lady of Confidence, you have shown special care for seminarians throughout history. The image enshrined at the Lateran has been a source of grace for those preparing for the priesthood.',
        '',
        'We ask you to intercede for all seminarians, that they may grow in holiness, wisdom, and love for Christ and His Church. Protect them from temptation and strengthen their vocations.',
        '',
        'Pray also for an increase in vocations to the priesthood and religious life, that the Church may never lack holy ministers of the Gospel.'
      ],
      prayer: 'Our Lady of Confidence, Mother of Priests, intercede for all seminarians and those discerning a vocation.',
      reflection: 'How can I pray for and support those who are preparing for ministry in the Church?',
      scripture: 'The harvest is plentiful, but the laborers are few; pray therefore the Lord of the harvest to send out laborers into his harvest. (Matthew 9:37-38)'
    },
    {
      day: 4,
      title: 'Day 4 - Prayer for the Pope',
      content: [
        'O Mary, Our Lady of Confidence, many popes have shown particular devotion to you under this title, including Pope Gregory XVI who granted your image a canonical coronation, and Saints Pius X, John Paul II, and Pope Benedict XVI.',
        '',
        'We ask you to intercede for our Holy Father, that he may be strengthened in his mission to lead the Church. Grant him wisdom, courage, and the grace to be a faithful shepherd.',
        '',
        'Help all the faithful to support and pray for the Pope, that the Church may be united under his leadership.'
      ],
      prayer: 'Our Lady of Confidence, protect our Holy Father and guide the Church in truth and love.',
      reflection: 'How can I support the Pope through my prayers and faithful obedience to the Church\'s teachings?',
      scripture: 'And I tell you, you are Peter, and on this rock I will build my church. (Matthew 16:18)'
    },
    {
      day: 5,
      title: 'Day 5 - Growth in Devotion',
      content: [
        'O Mary, Our Lady of Confidence, Sister Clara Isabel Fornari was granted a mystical experience in which you promised that all who venerate your image would be granted special graces.',
        '',
        'We ask you to increase our devotion to you and confidence in your ability to bring us great favors and even miracles. Help us to turn to you in all our needs with childlike trust.',
        '',
        'Grant us the grace to grow in love for you, knowing that you always lead us closer to your Son, Jesus.'
      ],
      prayer: 'Our Lady of Confidence, increase our devotion to you and trust in your intercession.',
      reflection: 'How can I deepen my relationship with Mary and grow in confidence in her maternal care?',
      scripture: 'And Mary said, "My soul magnifies the Lord, and my spirit rejoices in God my Savior." (Luke 1:46-47)'
    },
    {
      day: 6,
      title: 'Day 6 - Deeper Friendship with Jesus',
      content: [
        'O Mary, Our Lady of Confidence, no one knew Jesus more intimately than you. As His mother, you cared for Him, taught Him, and walked with Him throughout His earthly life.',
        '',
        'We ask you to help us develop a closer friendship with Jesus. Teach us to know Him, love Him, and serve Him as you did. Lead us into deeper communion with your Son through prayer and the sacraments.',
        '',
        'Help us to see Jesus not just as our Lord, but as our dearest friend who desires to be close to us.'
      ],
      prayer: 'Our Lady of Confidence, draw us into deeper friendship with your Son, Jesus.',
      reflection: 'How can I cultivate a more personal and intimate relationship with Jesus?',
      scripture: 'No longer do I call you servants...but I have called you friends. (John 15:15)'
    },
    {
      day: 7,
      title: 'Day 7 - Universal Respect for Mary',
      content: [
        'O Mary, Our Lady of Confidence, throughout the ages you have demonstrated your maternal care for all people. Your intercession has brought countless blessings to those who honor you.',
        '',
        'We pray that all in our world may grow in respect for you and recognition of your role in salvation history. Help those who do not yet know you to discover your loving care.',
        '',
        'Grant that devotion to you may spread throughout the world, bringing souls closer to Christ through your maternal guidance.'
      ],
      prayer: 'Our Lady of Confidence, may all people come to know and honor you as their Mother.',
      reflection: 'How can I share devotion to Mary with others in a way that draws them closer to Christ?',
      scripture: 'For behold, from now on all generations will call me blessed. (Luke 1:48)'
    },
    {
      day: 8,
      title: 'Day 8 - Trust in God\'s Providence',
      content: [
        'O Mary, Our Lady of Confidence, your entire life was marked by complete trust in God\'s providence. From the Annunciation to the Cross, you surrendered yourself to the Father\'s will.',
        '',
        'We ask you to help us grow in trust in God and in the power of your intercession. When we are anxious or fearful, remind us that God is in control and that He works all things for our good.',
        '',
        'Grant us the grace to surrender our worries to God and to rest in His loving providence.'
      ],
      prayer: 'Our Lady of Confidence, help us to trust completely in God\'s loving providence.',
      reflection: 'What fears or anxieties do I need to surrender to God\'s providence today?',
      scripture: 'Trust in the Lord with all your heart, and do not lean on your own understanding. (Proverbs 3:5)'
    },
    {
      day: 9,
      title: 'Day 9 - Strength of the Church',
      content: [
        'O Mary, Our Lady of Confidence, as we conclude this novena, we entrust the Church to your maternal care. In a world that often opposes the Gospel, be our refuge and strength.',
        '',
        'We pray for the strength of your Son\'s Church in our modern world. Protect her from her enemies, heal her divisions, and help her to be a beacon of hope and truth for all people.',
        '',
        'Grant that we may be faithful members of the Church, working for her growth and sanctification. May we have confidence that Christ\'s promise to be with His Church until the end of time will never fail.'
      ],
      prayer: 'Our Lady of Confidence, protect and strengthen the Church in our troubled times.',
      reflection: 'How can I contribute to the strength and unity of the Church through my prayers and actions?',
      scripture: 'And I tell you, you are Peter, and on this rock I will build my church, and the gates of hell shall not prevail against it. (Matthew 16:18)'
    }
  ],
  'st-george': [
    {
      day: 1,
      title: 'Day 1 - Family Holiness',
      content: [
        'O glorious St. George, you were raised by faithful Christian parents who instilled in you a deep love for God. Your family\'s faith became the foundation for your heroic witness.',
        '',
        'We thank God for giving us your example of holiness rooted in family. Help us to cultivate holiness in our own families, passing on the faith to the next generation.',
        '',
        'Intercede for all families, that they may be schools of faith, hope, and love, forming saints for the Kingdom of God.'
      ],
      prayer: 'St. George, patron of families, pray that our homes may be places of holiness and faith.',
      reflection: 'How can I help my family grow in holiness and pass on the faith to the next generation?',
      scripture: 'Train up a child in the way he should go; even when he is old he will not depart from it. (Proverbs 22:6)'
    },
    {
      day: 2,
      title: 'Day 2 - Soldier\'s Faith',
      content: [
        'O courageous St. George, you served as a Roman soldier while remaining faithful to Christ. Even when Emperor Diocletian demanded you renounce your faith, you stood firm.',
        '',
        'We ask for your intercession for all soldiers and military personnel. Protect them from harm and help them to maintain their faith even in the most difficult circumstances.',
        '',
        'Grant us the same steadfastness in our faith, that we may never compromise our beliefs regardless of the cost.'
      ],
      prayer: 'St. George, patron of soldiers, protect all who serve and keep them faithful to Christ.',
      reflection: 'How can I stand firm in my faith when facing pressure to compromise?',
      scripture: 'Be watchful, stand firm in the faith, act like men, be strong. (1 Corinthians 16:13)'
    },
    {
      day: 3,
      title: 'Day 3 - Courage and Virtue',
      content: [
        'O valiant St. George, the legend of your slaying the dragon represents your victory over evil through courage and virtue. You show us that with God\'s help, we can overcome any spiritual enemy.',
        '',
        'We ask for growth in courage and virtue. Help us to face our fears and to battle against the spiritual dragons in our lives - sin, temptation, and the works of the evil one.',
        '',
        'Grant us the grace to be spiritual warriors, armed with faith and protected by God\'s grace.'
      ],
      prayer: 'St. George, dragon slayer, help us to overcome evil with courage and virtue.',
      reflection: 'What spiritual dragons do I need to confront with courage and faith?',
      scripture: 'Be strong and courageous. Do not be frightened, for the Lord your God is with you wherever you go. (Joshua 1:9)'
    },
    {
      day: 4,
      title: 'Day 4 - Conversion of Souls',
      content: [
        'O zealous St. George, your witness of faith led many to conversion, even in the midst of persecution. Your courage inspired others to embrace Christ.',
        '',
        'We ask for the conversion of all who do not yet know Christ. Use us as instruments of Your grace to lead others to faith through our words and example.',
        '',
        'Help us to be bold witnesses to the Gospel, trusting that God can use our testimony to touch hearts and transform lives.'
      ],
      prayer: 'St. George, witness of faith, intercede for the conversion of souls.',
      reflection: 'How can my life be a witness that leads others to Christ?',
      scripture: 'You are the light of the world...let your light shine before others. (Matthew 5:14-16)'
    },
    {
      day: 5,
      title: 'Day 5 - Protection by the Cross',
      content: [
        'O blessed St. George, you found strength and protection in the Sign of the Cross. This holy sign was your shield against the attacks of the enemy.',
        '',
        'We ask for your intercession that we may always reverence the Cross of Christ and find in it our protection and salvation. Help new converts to embrace the Cross with love.',
        '',
        'Grant us the grace to glory in the Cross, knowing that through it we have been redeemed and set free.'
      ],
      prayer: 'St. George, devotee of the Cross, help us to find our strength in Christ crucified.',
      reflection: 'How can I more deeply embrace the Cross in my daily life?',
      scripture: 'But far be it from me to glory except in the cross of our Lord Jesus Christ. (Galatians 6:14)'
    },
    {
      day: 6,
      title: 'Day 6 - Strength for the Persecuted',
      content: [
        'O suffering St. George, you endured terrible torture for your faith, yet you never wavered. Your constancy in suffering gives hope to all who face persecution.',
        '',
        'We ask for your intercession for all persecuted Christians around the world. Strengthen them in their trials and help them to remain faithful even unto death.',
        '',
        'Grant us the grace to support our persecuted brothers and sisters through prayer, advocacy, and action.'
      ],
      prayer: 'St. George, martyr of Christ, strengthen all who suffer persecution for their faith.',
      reflection: 'How can I pray for and support Christians who face persecution?',
      scripture: 'Blessed are those who are persecuted for righteousness\' sake, for theirs is the kingdom of heaven. (Matthew 5:10)'
    },
    {
      day: 7,
      title: 'Day 7 - Fortitude Against Temptation',
      content: [
        'O steadfast St. George, when offered wealth and power to renounce Christ, you refused. No worldly temptation could shake your commitment to God.',
        '',
        'We ask for the gift of fortitude to resist temptation. When the world offers us false promises in exchange for compromising our faith, help us to stand firm.',
        '',
        'Grant us the wisdom to recognize temptation and the strength to choose God above all earthly rewards.'
      ],
      prayer: 'St. George, model of fortitude, help us to resist all temptation with courage.',
      reflection: 'What worldly temptations do I need to resist more firmly?',
      scripture: 'No temptation has overtaken you that is not common to man. God is faithful, and he will not let you be tempted beyond your ability. (1 Corinthians 10:13)'
    },
    {
      day: 8,
      title: 'Day 8 - Generosity and Charity',
      content: [
        'O generous St. George, even on your deathbed you thought of others, giving all your possessions to the poor. Your charity extended to your final breath.',
        '',
        'We ask for growth in genuine charity. Help us to be generous with our time, talents, and resources, always thinking of those in need.',
        '',
        'Grant us hearts that are moved by the suffering of others and hands that are quick to help.'
      ],
      prayer: 'St. George, model of charity, teach us to give generously to those in need.',
      reflection: 'How can I be more generous in serving the poor and those in need?',
      scripture: 'Give, and it will be given to you; good measure, pressed down, shaken together, running over. (Luke 6:38)'
    },
    {
      day: 9,
      title: 'Day 9 - Loyalty to Christ and His Church',
      content: [
        'O faithful St. George, your loyalty to Christ never wavered, even when it cost you your life. You showed that nothing is more precious than friendship with God.',
        '',
        'As we conclude this novena, we ask for the grace of perseverance. Help us to remain loyal to Christ and His Church throughout our lives, no matter what challenges we face.',
        '',
        'Grant us a deep and lasting friendship with God, that we may one day join you in the eternal kingdom.'
      ],
      prayer: 'St. George, faithful servant of Christ, help us to persevere in faith until the end.',
      reflection: 'How can I strengthen my commitment to Christ and His Church?',
      scripture: 'Be faithful unto death, and I will give you the crown of life. (Revelation 2:10)'
    }
  ],
  'st-alexander': [
    {
      day: 1,
      title: 'Day 1 - Love of Learning',
      content: [
        'O holy St. Alexander, you studied at the renowned Christian School of Alexandria, growing in wisdom and knowledge of the faith. Your education prepared you for great service to the Church.',
        '',
        'We ask for your intercession for all students and scholars. Help them to pursue knowledge with humility and to use their learning for the glory of God and the service of others.',
        '',
        'Grant us a love of learning, especially in the things of God, that we may grow in understanding of our faith.'
      ],
      prayer: 'St. Alexander, lover of sacred learning, intercede for all who seek wisdom and knowledge.',
      reflection: 'How can I grow in knowledge of my faith and use my learning to serve God?',
      scripture: 'The fear of the Lord is the beginning of wisdom, and the knowledge of the Holy One is insight. (Proverbs 9:10)'
    },
    {
      day: 2,
      title: 'Day 2 - Episcopal Service',
      content: [
        'O devoted St. Alexander, you served the Church first as bishop of Cappadocia and then as coadjutor bishop of Jerusalem alongside the elderly St. Narcissus. You gave your life in service to God\'s people.',
        '',
        'We ask for your intercession for all bishops and church leaders. Grant them wisdom, holiness, and courage to shepherd their flocks faithfully.',
        '',
        'Help us to support our bishops through prayer and to receive their teaching with humble and obedient hearts.'
      ],
      prayer: 'St. Alexander, faithful bishop, intercede for all who shepherd the Church.',
      reflection: 'How can I better support and pray for the bishops and clergy of the Church?',
      scripture: 'Keep watch over yourselves and over all the flock, of which the Holy Spirit has made you overseers. (Acts 20:28)'
    },
    {
      day: 3,
      title: 'Day 3 - Pilgrimage of Faith',
      content: [
        'O pilgrim St. Alexander, you made a pilgrimage to Jerusalem to visit the holy sites, and there you were called to serve the Church in a new way. Your journey led to unexpected grace.',
        '',
        'We ask for openness to God\'s surprises in our lives. Help us to see our life as a pilgrimage toward heaven, always ready to respond to God\'s call.',
        '',
        'Grant us the grace to embrace the unexpected turns in our journey, trusting that God is leading us.'
      ],
      prayer: 'St. Alexander, pilgrim of faith, guide us on our journey to the heavenly Jerusalem.',
      reflection: 'How can I be more open to God\'s surprises and unexpected calls in my life?',
      scripture: 'For here we have no lasting city, but we seek the city that is to come. (Hebrews 13:14)'
    },
    {
      day: 4,
      title: 'Day 4 - Faithful Service',
      content: [
        'O humble St. Alexander, when asked to serve as coadjutor bishop alongside St. Narcissus, you did not seek honor for yourself but worked humbly alongside another. You established a theological library for the benefit of the Church.',
        '',
        'We ask for the grace of faithful service. Help us to serve without seeking recognition, working for the good of others and the glory of God.',
        '',
        'Grant us humble hearts that find joy in building up the Church, even in hidden ways.'
      ],
      prayer: 'St. Alexander, faithful servant, teach us to serve with humility and dedication.',
      reflection: 'How can I serve the Church more faithfully, even in ways that go unnoticed?',
      scripture: 'Whoever would be great among you must be your servant. (Matthew 20:26)'
    },
    {
      day: 5,
      title: 'Day 5 - Perseverance Through Suffering',
      content: [
        'O suffering St. Alexander, you endured imprisonment and torture during the persecution of Christians under Emperor Severus, yet you emerged with your faith intact to continue serving the Church.',
        '',
        'We ask for the grace of perseverance through suffering. When trials come, help us to unite our suffering to Christ\'s and to emerge stronger in faith.',
        '',
        'Grant us hope in the midst of difficulty, knowing that God can bring good from every trial.'
      ],
      prayer: 'St. Alexander, persevering saint, help us to endure trials with faith and hope.',
      reflection: 'How can I persevere through current difficulties with greater faith?',
      scripture: 'Count it all joy, my brothers, when you meet trials of various kinds. (James 1:2)'
    },
    {
      day: 6,
      title: 'Day 6 - Steadfastness in Two Persecutions',
      content: [
        'O constant St. Alexander, you faced persecution not once but twice, under both Severus and Decius. Your faith remained unshaken through repeated trials.',
        '',
        'We ask for steadfast faith that endures repeated challenges. When we face ongoing difficulties or recurring temptations, help us to remain faithful.',
        '',
        'Grant us the grace to never give up, no matter how many times we are tested.'
      ],
      prayer: 'St. Alexander, steadfast in faith, help us to persevere through every trial.',
      reflection: 'What recurring challenges require ongoing perseverance in my life?',
      scripture: 'And let steadfastness have its full effect, that you may be perfect and complete, lacking in nothing. (James 1:4)'
    },
    {
      day: 7,
      title: 'Day 7 - Courageous Endurance',
      content: [
        'O courageous St. Alexander, you chose imprisonment and torture rather than renouncing your faith. Your courage inspires all who face difficult choices.',
        '',
        'We ask for courage to make difficult choices for our faith. When we face situations that require us to stand firm, give us the strength to endure.',
        '',
        'Grant us the grace to choose faithfulness over comfort, knowing that God rewards those who persevere.'
      ],
      prayer: 'St. Alexander, courageous martyr, grant us courage to stand firm in our faith.',
      reflection: 'What difficult choices for my faith am I facing? How can I choose courage?',
      scripture: 'Have I not commanded you? Be strong and courageous. (Joshua 1:9)'
    },
    {
      day: 8,
      title: 'Day 8 - Faithfulness in Old Age',
      content: [
        'O persevering St. Alexander, even in old age you continued to serve the Church and ultimately died in prison for your faith. Your faithfulness never waned.',
        '',
        'We ask for the grace to remain faithful throughout our entire lives. Help us to serve God with vigor in youth and with constancy in old age.',
        '',
        'Grant us the blessing of final perseverance, that we may be faithful to the end.'
      ],
      prayer: 'St. Alexander, faithful unto death, help us to persevere in faith throughout our lives.',
      reflection: 'How can I prepare now to remain faithful to God throughout my entire life?',
      scripture: 'I have fought the good fight, I have finished the race, I have kept the faith. (2 Timothy 4:7)'
    },
    {
      day: 9,
      title: 'Day 9 - Unwavering Commitment',
      content: [
        'O blessed St. Alexander, as we conclude this novena, we honor your unwavering commitment to Christ. You died in prison around 251 AD, giving your life for the faith you loved.',
        '',
        'We ask for an unwavering commitment to Christ that lasts until our final breath. Help us to make choices each day that strengthen our resolve to follow Him.',
        '',
        'Grant us the grace of a holy death, that we may pass from this life to eternal glory in the company of the saints.'
      ],
      prayer: 'St. Alexander, faithful martyr, help us to live and die in unwavering faith.',
      reflection: 'How can I strengthen my commitment to Christ today?',
      scripture: 'Be faithful unto death, and I will give you the crown of life. (Revelation 2:10)'
    }
  ],
  'st-benedict': [
    {
      day: 1,
      title: 'Day 1 - For Those in Religious Orders',
      content: [
        'Holy St. Benedict, you are the father of Western monasticism. Your Rule has guided countless men and women in the religious life for over 1500 years.',
        '',
        'We pray today for all those in religious orders who follow your Rule. May they find in your wisdom a path to holiness and union with God.',
        '',
        'What can be sweeter to us, dear ones, than this voice of the Lord inviting us? Having our loins girded with faith and the performance of good works, let us walk in His paths by the guidance of the Gospel, that we may deserve to see Him who has called us to His kingdom.'
      ],
      prayer: 'St. Benedict, pray for all monks, nuns, and religious who follow your holy Rule.',
      reflection: 'How can I support and pray for those in religious life?',
      scripture: 'Come, follow me, and I will make you fishers of men. (Matthew 4:19)'
    },
    {
      day: 2,
      title: 'Day 2 - For Working Professionals',
      content: [
        'Holy St. Benedict, your motto was "Ora et Labora" - Pray and Work. You taught that all honest work can be prayer when offered to God.',
        '',
        'We pray today for all working professionals who strive to balance their jobs with family and faith. Help them find holiness in their daily labor.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? Grant that all who work may see their labor as service to God and neighbor.'
      ],
      prayer: 'St. Benedict, pray for all who work, that they may sanctify their labor through prayer.',
      reflection: 'How can I offer my daily work as prayer to God?',
      scripture: 'Whatever you do, work heartily, as for the Lord and not for men. (Colossians 3:23)'
    },
    {
      day: 3,
      title: 'Day 3 - For Parents',
      content: [
        'Holy St. Benedict, you understood the demands of schedules and obligations. Parents today are often governed by the needs and schedules of their children.',
        '',
        'We pray for all parents who sacrifice so much for their families. Help them find moments of prayer amidst the busyness and to see their parental duties as a path to holiness.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? May all parents hear Your call in the cries of their children.'
      ],
      prayer: 'St. Benedict, pray for all parents, that they may raise their children in faith and love.',
      reflection: 'How can parents find God in the midst of family life?',
      scripture: 'Train up a child in the way he should go; even when he is old he will not depart from it. (Proverbs 22:6)'
    },
    {
      day: 4,
      title: 'Day 4 - For Children',
      content: [
        'Holy St. Benedict, children are subject to the authority of parents, teachers, and coaches. They must learn obedience and discipline.',
        '',
        'We pray for all children who must navigate the demands placed upon them. Help them to grow in virtue through proper obedience and to find joy in learning.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? May all children hear God\'s voice calling them to holiness.'
      ],
      prayer: 'St. Benedict, pray for all children, that they may grow in wisdom and grace.',
      reflection: 'How can we help children encounter God through healthy structure and discipline?',
      scripture: 'Let the children come to me, and do not hinder them, for to such belongs the kingdom of heaven. (Matthew 19:14)'
    },
    {
      day: 5,
      title: 'Day 5 - For Those Experiencing Poverty',
      content: [
        'Holy St. Benedict, you left wealth and privilege to embrace voluntary poverty. Many in our world experience poverty not by choice but by circumstance.',
        '',
        'We pray for all those experiencing poverty and housing insecurity. May they find hope in God\'s providence and may we be moved to serve them.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? Help us to see Christ in the poor and to serve them with compassion.'
      ],
      prayer: 'St. Benedict, pray for all who suffer from poverty, that they may experience God\'s care through us.',
      reflection: 'How can I respond to those experiencing poverty in my community?',
      scripture: 'Blessed are the poor in spirit, for theirs is the kingdom of heaven. (Matthew 5:3)'
    },
    {
      day: 6,
      title: 'Day 6 - For the Imprisoned',
      content: [
        'Holy St. Benedict, those who are imprisoned live under strict schedules imposed by others. Their freedom is severely restricted.',
        '',
        'We pray for all who are incarcerated. May they find interior freedom in Christ even when external freedom is denied. May they encounter God\'s mercy and find paths to rehabilitation and redemption.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? May all prisoners hear Your voice calling them to conversion.'
      ],
      prayer: 'St. Benedict, pray for all who are imprisoned, that they may find freedom in Christ.',
      reflection: 'How can I support prison ministry and pray for those who are incarcerated?',
      scripture: 'I was in prison and you came to me. (Matthew 25:36)'
    },
    {
      day: 7,
      title: 'Day 7 - For Military Personnel',
      content: [
        'Holy St. Benedict, military personnel live under rigorous discipline and schedules. They sacrifice much for the service of their country.',
        '',
        'We pray for all who serve in the military. Protect them from harm, help them maintain their faith, and guide their actions toward justice and peace.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? May all who serve find strength in Your presence.'
      ],
      prayer: 'St. Benedict, pray for all military personnel, that they may serve with honor and return safely.',
      reflection: 'How can I support and pray for those who serve in the military?',
      scripture: 'Greater love has no one than this, that someone lay down his life for his friends. (John 15:13)'
    },
    {
      day: 8,
      title: 'Day 8 - For the Enslaved',
      content: [
        'Holy St. Benedict, tragically, slavery still exists in our world. Many suffer under unjust bondage and oppression.',
        '',
        'We pray for all who are enslaved or trafficked. May they be freed from their bondage and may those who exploit them be brought to justice.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? May all who are in bondage be set free by Your liberating grace.'
      ],
      prayer: 'St. Benedict, pray for all who are enslaved, that they may be set free.',
      reflection: 'How can I work against human trafficking and modern slavery?',
      scripture: 'The Spirit of the Lord is upon me, because he has anointed me to proclaim liberty to the captives. (Luke 4:18)'
    },
    {
      day: 9,
      title: 'Day 9 - For the Sick and Infirm',
      content: [
        'Holy St. Benedict, those who are infirm often become dependent on medical care and the schedules of others for their daily needs.',
        '',
        'We pray for all who are sick, disabled, or dependent on care. May they find comfort in God\'s love and may their caregivers serve them with patience and compassion.',
        '',
        'What can be sweeter to us than this voice of the Lord inviting us? As we conclude this novena, may all who suffer illness find healing and peace in You.'
      ],
      prayer: 'St. Benedict, pray for all who are sick and those who care for them.',
      reflection: 'How can I bring comfort to those who are ill or suffering?',
      scripture: 'Is anyone among you sick? Let him call for the elders of the church, and let them pray over him. (James 5:14)'
    }
  ],
  'st-thomas-aquinas': [
    {
      day: 1,
      title: 'Day 1 - For Students and Learners',
      content: [
        'O glorious St. Thomas Aquinas, Angelic Doctor of the Church, you dedicated your life to the pursuit of truth and wisdom. Though called "Dumb Ox" in your youth, you became one of the greatest minds in history.',
        '',
        'We pray for all students and learners. Help them to approach their studies with diligence and humility, seeking not just knowledge but wisdom.',
        '',
        'Grant that all who study may use their learning for the glory of God and the service of others.'
      ],
      prayer: 'St. Thomas Aquinas, patron of students, pray that all learners may grow in wisdom and grace.',
      reflection: 'How can I approach learning with greater humility and openness to truth?',
      scripture: 'If any of you lacks wisdom, let him ask God, who gives generously to all without reproach. (James 1:5)'
    },
    {
      day: 2,
      title: 'Day 2 - For the Church\'s Growth',
      content: [
        'O wise St. Thomas Aquinas, your teachings have shaped Catholic thought for centuries. Your Summa Theologica remains a masterwork of theological reflection.',
        '',
        'We pray for the growth of the Church, for priests, missionaries, and all who spread the Gospel. May the Church continue to grow in wisdom and in numbers.',
        '',
        'Help all who teach the faith to do so with clarity and love, following your example of brilliant yet humble service.'
      ],
      prayer: 'St. Thomas Aquinas, pray for the growth and unity of the Church throughout the world.',
      reflection: 'How can I contribute to the growth and vitality of the Church?',
      scripture: 'Go therefore and make disciples of all nations. (Matthew 28:19)'
    },
    {
      day: 3,
      title: 'Day 3 - Reverence for the Eucharist',
      content: [
        'O devoted St. Thomas Aquinas, you composed beautiful hymns for the Feast of Corpus Christi, including the Tantum Ergo and Panis Angelicus. Your love for the Eucharist was profound.',
        '',
        'We pray for greater reverence for the Eucharist in our world. Help all Catholics to recognize the Real Presence of Christ and to receive Him with faith and devotion.',
        '',
        'Grant us a deeper love for the Blessed Sacrament and a desire to spend time in adoration.'
      ],
      prayer: 'St. Thomas Aquinas, lover of the Eucharist, increase our faith in Christ\'s Real Presence.',
      reflection: 'How can I deepen my reverence and love for the Eucharist?',
      scripture: 'This is my body, which is given for you. Do this in remembrance of me. (Luke 22:19)'
    },
    {
      day: 4,
      title: 'Day 4 - Humility When Facing Criticism',
      content: [
        'O humble St. Thomas Aquinas, you were mocked as a "Dumb Ox" by your classmates, yet you responded with patience and humility. Your teacher St. Albert the Great recognized your hidden genius.',
        '',
        'We pray for humility when we face criticism or misunderstanding. Help us to respond with grace and to trust that God sees our true worth.',
        '',
        'Grant us the wisdom to learn from valid criticism and the peace to let go of unjust attacks.'
      ],
      prayer: 'St. Thomas Aquinas, model of humility, help us to respond to criticism with grace.',
      reflection: 'How do I typically respond to criticism? How can I grow in humility?',
      scripture: 'A soft answer turns away wrath, but a harsh word stirs up anger. (Proverbs 15:1)'
    },
    {
      day: 5,
      title: 'Day 5 - Patience in Discerning Vocations',
      content: [
        'O patient St. Thomas Aquinas, your family strongly opposed your desire to become a Dominican friar. They even imprisoned you for a year, but you remained steadfast in your vocation.',
        '',
        'We pray for all who are discerning their vocation. Grant them patience and perseverance, especially when they face opposition or uncertainty.',
        '',
        'Help us to support those discerning a call to priesthood or religious life, rather than placing obstacles in their way.'
      ],
      prayer: 'St. Thomas Aquinas, pray for all who are discerning their vocation in life.',
      reflection: 'How can I better support those discerning a vocation to priesthood or religious life?',
      scripture: 'For I know the plans I have for you, declares the Lord, plans for welfare and not for evil. (Jeremiah 29:11)'
    },
    {
      day: 6,
      title: 'Day 6 - Seeking Divine Guidance',
      content: [
        'O prayerful St. Thomas Aquinas, before writing, you would always pray, seeking God\'s guidance. You understood that true wisdom comes from above.',
        '',
        'We pray for the grace to seek divine guidance in all we do. Help us to pause and pray before making important decisions, trusting in God\'s wisdom rather than our own.',
        '',
        'Grant us hearts that are attentive to the Holy Spirit\'s inspiration.'
      ],
      prayer: 'St. Thomas Aquinas, pray that we may always seek God\'s guidance through prayer.',
      reflection: 'Do I regularly seek God\'s guidance before important decisions and undertakings?',
      scripture: 'Trust in the Lord with all your heart, and do not lean on your own understanding. (Proverbs 3:5)'
    },
    {
      day: 7,
      title: 'Day 7 - Charity and Respect for Others',
      content: [
        'O charitable St. Thomas Aquinas, even when refuting errors, you always treated opponents with respect. You sought truth, not victory in argument.',
        '',
        'We pray for charity in our interactions, especially in disagreements. Help us to respect those with whom we differ and to seek truth together.',
        '',
        'Grant us the wisdom to distinguish between error and the person who holds it, loving all while standing firm in truth.'
      ],
      prayer: 'St. Thomas Aquinas, teach us to pursue truth with charity and respect for all.',
      reflection: 'How can I engage in disagreements with greater charity and respect?',
      scripture: 'Speaking the truth in love, we are to grow up in every way into him who is the head, into Christ. (Ephesians 4:15)'
    },
    {
      day: 8,
      title: 'Day 8 - Truth-Seeking and Gospel Witness',
      content: [
        'O truth-loving St. Thomas Aquinas, you dedicated your life to understanding and explaining the faith. You showed that faith and reason are not opposed but work together.',
        '',
        'We pray for all who seek truth, especially those who struggle with faith. Help them to encounter the Gospel and to find in Christ the Truth they seek.',
        '',
        'Grant us the courage to be witnesses to the truth in a world that often rejects it.'
      ],
      prayer: 'St. Thomas Aquinas, help us to seek truth and witness to the Gospel boldly.',
      reflection: 'How can I be a better witness to truth in my daily life?',
      scripture: 'Jesus said to him, "I am the way, and the truth, and the life." (John 14:6)'
    },
    {
      day: 9,
      title: 'Day 9 - Purity and Chastity',
      content: [
        'O pure St. Thomas Aquinas, when tempted against chastity, you drove away the temptation with a burning brand. Angels then girded you with a cord of purity.',
        '',
        'As we conclude this novena, we pray for the gift of purity and chastity. Help us to resist temptations against these virtues and to keep our minds and hearts fixed on God.',
        '',
        'On your deathbed, you said your writings seemed "like so much straw" compared to what you had seen. Grant us such a vision of God\'s glory that all earthly things pale in comparison.'
      ],
      prayer: 'St. Thomas Aquinas, pray for us that we may live in purity and one day see God face to face.',
      reflection: 'How can I grow in purity of heart, mind, and body?',
      scripture: 'Blessed are the pure in heart, for they shall see God. (Matthew 5:8)'
    }
  ],
  'mother-teresa': [
    {
      day: 1,
      title: 'Day 1 - Know the Living Jesus',
      content: [
        '"Don\'t search for Jesus in far lands; He is not there. He is close to you; He is in you." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you knew Jesus not as a distant figure but as a living presence within you. Your life radiated His love to all you met.',
        '',
        'Help us to know the living Jesus who dwells in our hearts. May His love become so real in us that others see Him when they see us.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may know Jesus living within us and radiate His love to others.',
      reflection: 'Do I experience Jesus as a living presence in my life, or does He seem distant?',
      scripture: 'It is no longer I who live, but Christ who lives in me. (Galatians 2:20)'
    },
    {
      day: 2,
      title: 'Day 2 - Jesus Loves You',
      content: [
        '"Do not be afraid - you are precious to Jesus. He loves you." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you spent your life reminding the poorest of the poor that they were loved. You saw the infinite value of every human person.',
        '',
        'Help us to truly believe that we are precious to Jesus and that He loves us unconditionally. May this knowledge transform how we see ourselves and others.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may know how deeply Jesus loves us.',
      reflection: 'Do I truly believe that I am precious to Jesus? How does this affect how I live?',
      scripture: 'See what kind of love the Father has given to us, that we should be called children of God. (1 John 3:1)'
    },
    {
      day: 3,
      title: 'Day 3 - Hear Him Say "I Thirst"',
      content: [
        '"Just think! God is thirsting for you and me to come forward to satiate His thirst." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you heard Jesus cry "I thirst" not just on the Cross but in every suffering person you met. His thirst for souls became your mission.',
        '',
        'Help us to understand Christ\'s desire for our love and to respond generously. May we satisfy His thirst through our love and service.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may hear and respond to Jesus\'s thirst for our love.',
      reflection: 'How do I respond to Jesus\'s thirst for my love and the love of all souls?',
      scripture: 'Jesus said, "I thirst." (John 19:28)'
    },
    {
      day: 4,
      title: 'Day 4 - Our Lady Will Help You',
      content: [
        '"How close we must keep to Our Lady who understood what depth of Divine Love was being revealed as she stood at the foot of the Cross..." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you had deep devotion to Mary, understanding that she alone fully grasped the mystery of God\'s redemptive love.',
        '',
        'Help us to draw close to Mary, who can teach us about her Son\'s love and help us respond to it more fully.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that Mary may help us understand and respond to God\'s love.',
      reflection: 'How can I deepen my relationship with Mary and learn from her example?',
      scripture: 'Standing by the cross of Jesus were his mother and his mother\'s sister. (John 19:25)'
    },
    {
      day: 5,
      title: 'Day 5 - Trust Jesus Fully',
      content: [
        '"Confidence in God can do all things. It is our emptiness and lowliness that God needs..." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, even in your dark night of the soul, you trusted Jesus completely. Your confidence in Him never wavered despite interior darkness.',
        '',
        'Help us to trust Jesus fully, especially when we feel empty or low. May our weakness become an opportunity for His strength to work in us.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may trust Jesus completely, especially in difficulty.',
      reflection: 'Can I trust Jesus even when I don\'t feel His presence or understand His ways?',
      scripture: 'My grace is sufficient for you, for my power is made perfect in weakness. (2 Corinthians 12:9)'
    },
    {
      day: 6,
      title: 'Day 6 - True Love is Surrender',
      content: [
        '"Allow God to use you without consulting you." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you surrendered yourself completely to God\'s will, allowing Him to use you however He wished. Your availability to God bore tremendous fruit.',
        '',
        'Help us to surrender our lives to God without reservation, trusting that His plans for us are better than anything we could imagine.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may surrender completely to God\'s will.',
      reflection: 'What areas of my life have I not fully surrendered to God?',
      scripture: 'Not my will, but yours, be done. (Luke 22:42)'
    },
    {
      day: 7,
      title: 'Day 7 - God Loves a Cheerful Giver',
      content: [
        '"Joy is the sign of union with God, of God\'s presence. Joy is love, the normal result of a heart burning with love." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, your joy was contagious. Even in the midst of great suffering, you radiated the joy that comes from union with God.',
        '',
        'Help us to serve with joy, knowing that cheerful giving pleases God and draws others to Him.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may serve God and others with joy.',
      reflection: 'Do I serve God and others with joy? What steals my joy?',
      scripture: 'God loves a cheerful giver. (2 Corinthians 9:7)'
    },
    {
      day: 8,
      title: 'Day 8 - Jesus in the Eucharist and the Poor',
      content: [
        '"Believe that He, Jesus, is in the appearance of Bread and that He, Jesus, is in the hungry, naked, sick, lonely, unloved, homeless, helpless and hopeless." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, you saw Jesus in the Eucharist and in the poorest of the poor. This double vision of Christ guided your entire life.',
        '',
        'Help us to recognize Jesus both in the Blessed Sacrament and in every suffering person we encounter.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may see Jesus in the Eucharist and in the poor.',
      reflection: 'Do I recognize Jesus in the poor and suffering? How do I respond?',
      scripture: 'As you did it to one of the least of these my brothers, you did it to me. (Matthew 25:40)'
    },
    {
      day: 9,
      title: 'Day 9 - Holiness is Jesus Living in Me',
      content: [
        '"Charity for each other is the surest way to great holiness." - Mother Teresa',
        '',
        'O St. Teresa of Calcutta, as we conclude this novena, we ask for the grace of holiness. You showed us that holiness is simply allowing Jesus to live and act through us.',
        '',
        'Help us to grow in holiness through charity, allowing Jesus to love others through us. May our lives bear witness to His presence within us.'
      ],
      prayer: 'St. Teresa of Calcutta, pray that we may become saints through loving service.',
      reflection: 'How can I allow Jesus to live and act more fully through me?',
      scripture: 'By this all people will know that you are my disciples, if you have love for one another. (John 13:35)'
    }
  ],
  'st-monica': [
    {
      day: 1,
      title: 'Day 1 - A Mother\'s Prayer',
      content: [
        'O St. Monica, you prayed for your son Augustine for seventeen years before his conversion. Your tears and prayers moved the heart of God.',
        '',
        'You never gave up hope, even when Augustine lived a sinful life and embraced heresy. Your faithful persistence is an inspiration to all who pray for wayward loved ones.',
        '',
        'Intercede for us that we may have your same perseverance in prayer, trusting that God hears and answers according to His perfect timing.'
      ],
      prayer: 'St. Monica, pray for us that we may never lose hope or cease praying for those we love.',
      reflection: 'For whom do I need to pray with St. Monica\'s persistence and hope?',
      scripture: 'And he told them a parable to the effect that they ought always to pray and not lose heart. (Luke 18:1)'
    },
    {
      day: 2,
      title: 'Day 2 - Patience in Suffering',
      content: [
        'O St. Monica, you suffered greatly as you watched your son wander from the faith. You also endured a difficult marriage to Patricius, who was not initially a Christian.',
        '',
        'Through patience and prayer, you won over your husband, who was baptized before his death. Your gentle witness proved more powerful than any argument.',
        '',
        'Help us to be patient in our sufferings and to trust that God can bring good from every trial.'
      ],
      prayer: 'St. Monica, pray for us that we may bear our sufferings with patience and hope.',
      reflection: 'How can I respond to family difficulties with greater patience and faith?',
      scripture: 'Love is patient and kind. (1 Corinthians 13:4)'
    },
    {
      day: 3,
      title: 'Day 3 - Unwavering Faith',
      content: [
        'O St. Monica, your faith in God\'s mercy never wavered, even when all seemed lost. A bishop once told you that "the son of so many tears cannot perish."',
        '',
        'You held onto that promise and continued to believe that Augustine would return to God. Your faith was rewarded beyond your greatest hopes.',
        '',
        'Help us to have unwavering faith in God\'s power to save, even when we see no signs of conversion in those we love.'
      ],
      prayer: 'St. Monica, pray for us that our faith may remain strong in times of doubt.',
      reflection: 'Do I truly believe that God can convert even the most hardened heart?',
      scripture: 'Is anything too hard for the Lord? (Genesis 18:14)'
    },
    {
      day: 4,
      title: 'Day 4 - The Power of Tears',
      content: [
        'O St. Monica, your tears were a powerful prayer. You wept for Augustine\'s sins as if they were your own, and your tears watered the seeds of grace in his heart.',
        '',
        'God does not despise a broken and contrite heart. Your sorrow for sin - both your own and your son\'s - was pleasing to God.',
        '',
        'Help us to weep for sin and to offer our tears as prayers for the conversion of sinners.'
      ],
      prayer: 'St. Monica, pray for us that our tears may become prayers that move God\'s heart.',
      reflection: 'Do I truly grieve over sin - my own and that of others?',
      scripture: 'The Lord is near to the brokenhearted and saves the crushed in spirit. (Psalm 34:18)'
    },
    {
      day: 5,
      title: 'Day 5 - Following Our Children',
      content: [
        'O St. Monica, when Augustine fled to Rome to escape your influence, you followed him. You would not abandon your mission to bring him to Christ.',
        '',
        'Your determination to follow Augustine to Rome and then to Milan was providential, for there he met St. Ambrose and was finally converted.',
        '',
        'Help us to follow our loved ones with prayer, never giving up on them no matter where they go.'
      ],
      prayer: 'St. Monica, pray for us that we may never abandon those who have strayed from the faith.',
      reflection: 'Am I willing to go to great lengths to help bring my loved ones back to God?',
      scripture: 'What woman, having ten silver coins, if she loses one coin, does not light a lamp and sweep the house and seek diligently until she finds it? (Luke 15:8)'
    },
    {
      day: 6,
      title: 'Day 6 - Joy in Conversion',
      content: [
        'O St. Monica, what joy you experienced when Augustine was finally baptized by St. Ambrose at the Easter Vigil in 387! Seventeen years of prayer had borne fruit beyond measure.',
        '',
        'Augustine not only returned to the faith but became a great bishop and Doctor of the Church. Your prayers produced a saint.',
        '',
        'Help us to trust that God can do more than we ask or imagine through our faithful prayers.'
      ],
      prayer: 'St. Monica, pray for us that we may persevere until we see the fruit of our prayers.',
      reflection: 'Do I trust that God can do more than I ask or imagine through my prayers?',
      scripture: 'Now to him who is able to do far more abundantly than all that we ask or think. (Ephesians 3:20)'
    },
    {
      day: 7,
      title: 'Day 7 - Peaceful Death',
      content: [
        'O St. Monica, shortly after Augustine\'s conversion, you told him that you had nothing left to live for - your one desire in life had been fulfilled.',
        '',
        'You died peacefully at Ostia, knowing that your son was in God\'s hands. Your life\'s work was complete, and you were ready to meet your Lord.',
        '',
        'Help us to be at peace, trusting that God will complete the work He has begun in our loved ones.'
      ],
      prayer: 'St. Monica, pray for us that we may find peace in God\'s timing and providence.',
      reflection: 'Can I trust God to complete the work He has begun in those I love?',
      scripture: 'He who began a good work in you will bring it to completion. (Philippians 1:6)'
    },
    {
      day: 8,
      title: 'Day 8 - Intercession for Mothers',
      content: [
        'O St. Monica, you are the patron saint of mothers, especially those who suffer because of wayward children. You understand the particular anguish of a mother\'s heart.',
        '',
        'Intercede for all mothers who weep for their children. Help them to turn their tears into prayers and to trust in God\'s mercy.',
        '',
        'May all mothers find in you a model of faith, hope, and persevering love.'
      ],
      prayer: 'St. Monica, patron of mothers, pray for all mothers who suffer for their children.',
      reflection: 'How can I support and encourage mothers who are struggling with wayward children?',
      scripture: 'As a mother comforts her child, so will I comfort you. (Isaiah 66:13)'
    },
    {
      day: 9,
      title: 'Day 9 - Becoming Saints',
      content: [
        'O St. Monica, as we conclude this novena, we remember your final wish. You asked Augustine to remember you at the altar of the Lord wherever he might be.',
        '',
        'Your prayer was not just for Augustine\'s conversion but that he would become a great saint. And so he did - one of the greatest Doctors of the Church.',
        '',
        'Pray for us that we may turn from our sins and become great saints for the glory of God, following your example of faithful, persistent prayer.'
      ],
      prayer: 'St. Monica, pray for us that we and our loved ones may become saints.',
      reflection: 'Do I pray not just for conversion but for sanctity - for myself and my loved ones?',
      scripture: 'Be holy, for I am holy. (1 Peter 1:16)'
    }
  ],
  'guardian-angel': [
    {
      day: 1,
      title: 'Day 1 - My Counselor',
      content: [
        'O holy Guardian Angel, God in His love has assigned you to watch over me. You are my heavenly counselor, guiding me toward what is good and true.',
        '',
        'Inspire me to be holy and good like you. Help me to listen to your gentle promptings and to follow your wise counsel in all my decisions.',
        '',
        'Teach me to become the person that God is calling me to be, and help me to be a light for others to know and love the Lord.'
      ],
      prayer: 'My guardian angel, my counselor, inspire me!',
      reflection: 'How can I become more attentive to my guardian angel\'s guidance?',
      scripture: 'For he will command his angels concerning you to guard you in all your ways. (Psalm 91:11)'
    },
    {
      day: 2,
      title: 'Day 2 - My Defender',
      content: [
        'O holy Guardian Angel, you are my defender against the attacks of the evil one. You protect me from spiritual and physical harm.',
        '',
        'Protect me from sin and bodily harm. Shield me from the temptations and snares of the devil. Help me to learn to defend and protect myself spiritually.',
        '',
        'Guard me on my journey through life, that I may reach my heavenly home safely.'
      ],
      prayer: 'My guardian angel, my defender, protect me!',
      reflection: 'Do I call upon my guardian angel when I face temptation or danger?',
      scripture: 'The angel of the Lord encamps around those who fear him, and delivers them. (Psalm 34:7)'
    },
    {
      day: 3,
      title: 'Day 3 - My Consoler',
      content: [
        'O holy Guardian Angel, you are my consoler in times of sorrow and difficulty. When life is hard and my body and soul are hurting, you are there to comfort me.',
        '',
        'Fortify me to be strong when life is hard. When I feel alone or discouraged, remind me of God\'s love and presence.',
        '',
        'Help me to find strength in God and to persevere through every trial.'
      ],
      prayer: 'My guardian angel, my consoler, fortify me!',
      reflection: 'Do I turn to my guardian angel for comfort in difficult times?',
      scripture: 'Blessed be the God and Father of our Lord Jesus Christ, the Father of mercies and God of all comfort. (2 Corinthians 1:3)'
    },
    {
      day: 4,
      title: 'Day 4 - My Teacher',
      content: [
        'O holy Guardian Angel, you are my teacher, instructing me in the ways of holiness. You show me by your example what it means to serve God faithfully.',
        '',
        'Instruct me to be holy and good like you. Teach me to pray, to love, and to serve as you do. Help me to grow in virtue each day.',
        '',
        'Guide me in learning the truths of faith and help me to live them out in my daily life.'
      ],
      prayer: 'My guardian angel, my teacher, instruct me!',
      reflection: 'What is my guardian angel teaching me about holiness?',
      scripture: 'All your children shall be taught by the Lord, and great shall be the peace of your children. (Isaiah 54:13)'
    },
    {
      day: 5,
      title: 'Day 5 - Witness of My Actions',
      content: [
        'O holy Guardian Angel, you witness all my actions, both good and bad. Nothing is hidden from your sight.',
        '',
        'Purify me to be holy and good like you. Refine and cleanse me of my sinful habits and keep me from temptation.',
        '',
        'Help me to live each moment aware that I am in God\'s presence and yours, choosing always what is pleasing to our Lord.'
      ],
      prayer: 'My guardian angel, witness of all my actions, purify me!',
      reflection: 'How would my behavior change if I were more aware of my guardian angel\'s presence?',
      scripture: 'You discern my thoughts from afar. You search out my path and my lying down and are acquainted with all my ways. (Psalm 139:2-3)'
    },
    {
      day: 6,
      title: 'Day 6 - My Helper',
      content: [
        'O holy Guardian Angel, you are my helper in all my needs. God has sent you to assist me on my journey to heaven.',
        '',
        'Support me to be holy and good like you. Help me to be the person that God is calling me to be. Assist me in my work, my relationships, and my prayer.',
        '',
        'Be with me in every moment, helping me to choose what is right and good.'
      ],
      prayer: 'My guardian angel, my helper, support me!',
      reflection: 'In what areas of my life do I need my guardian angel\'s help most?',
      scripture: 'Are they not all ministering spirits sent out to serve for the sake of those who are to inherit salvation? (Hebrews 1:14)'
    },
    {
      day: 7,
      title: 'Day 7 - My Intercessor',
      content: [
        'O holy Guardian Angel, you are my intercessor before the throne of God. You present my prayers to the Lord and plead for me.',
        '',
        'Speak for me to the Lord. Whisper my prayers into His ear so that I may be the person that God is calling me to be.',
        '',
        'Join your perfect prayers to my imperfect ones, that together we may give glory to God.'
      ],
      prayer: 'My guardian angel, my intercessor, speak for me!',
      reflection: 'Do I ask my guardian angel to present my prayers to God?',
      scripture: 'And the smoke of the incense, with the prayers of the saints, rose before God from the hand of the angel. (Revelation 8:4)'
    },
    {
      day: 8,
      title: 'Day 8 - My Guide',
      content: [
        'O holy Guardian Angel, you are my guide on the journey of life. You know the path that leads to heaven and you direct my steps.',
        '',
        'Direct me on my path in life and faith so that I may be holy and good like you. Keep me from danger, both spiritual and physical.',
        '',
        'Lead me always toward God, helping me to avoid the detours of sin and the dead ends of worldly attachment.'
      ],
      prayer: 'My guardian angel, my guide, direct me!',
      reflection: 'Am I following my guardian angel\'s guidance, or am I going my own way?',
      scripture: 'Behold, I send an angel before you to guard you on the way and to bring you to the place that I have prepared. (Exodus 23:20)'
    },
    {
      day: 9,
      title: 'Day 9 - My Light',
      content: [
        'O holy Guardian Angel, you are my light in the darkness of this world. You enlighten my mind and illuminate my path.',
        '',
        'Enlighten me to be holy and good like you. Open my eyes so that I may see how to be the person that God is calling me to be.',
        '',
        'As we conclude this novena, I thank you for your faithful presence and ask that you continue to guide me until I reach my eternal home, where we will praise God together forever.'
      ],
      prayer: 'My guardian angel, my light, enlighten me!',
      reflection: 'How has my guardian angel brought light into my life?',
      scripture: 'The Lord is my light and my salvation; whom shall I fear? (Psalm 27:1)'
    }
  ],
  'healing-childhood-trauma': [
    {
      day: 1,
      title: 'Day 1 - Healing from Abuse',
      content: [
        'Loving Father, we come before You asking for healing for all who experienced abuse in their childhood. The wounds of abuse run deep, affecting body, mind, and spirit.',
        '',
        'Pour out Your healing grace on all who carry these wounds. Help them to know that what happened to them was not their fault and that You love them infinitely.',
        '',
        'We ask You to bring healing, restoration, and peace to every person who suffered abuse as a child.'
      ],
      prayer: 'Lord Jesus, healer of all wounds, bring healing to those who suffered abuse.',
      reflection: 'How can I support those who are healing from childhood abuse?',
      scripture: 'He heals the brokenhearted and binds up their wounds. (Psalm 147:3)'
    },
    {
      day: 2,
      title: 'Day 2 - Healing from Accidents and Disasters',
      content: [
        'Loving Father, many carry trauma from accidents or disasters they experienced in childhood. These events left lasting marks on their hearts and minds.',
        '',
        'We offer all the suffering endured from these traumatic events to You. Transform this pain into a source of compassion and strength.',
        '',
        'Help all who suffered from accidents and disasters to find healing and to know Your protecting presence.'
      ],
      prayer: 'Lord Jesus, bring peace to those traumatized by accidents and disasters.',
      reflection: 'How has God brought good from difficult experiences in my life?',
      scripture: 'And we know that for those who love God all things work together for good. (Romans 8:28)'
    },
    {
      day: 3,
      title: 'Day 3 - Healing from Neglect',
      content: [
        'Loving Father, some wounds come not from what was done but from what was not done. Children who experienced neglect carry deep wounds of abandonment and unworthiness.',
        '',
        'Pour out Your love on all who were neglected as children. Help them to know that You will never neglect or abandon them.',
        '',
        'Grant growth in trust in You, even when human caregivers failed. Fill the empty places with Your perfect love.'
      ],
      prayer: 'Lord Jesus, Father of the fatherless, fill the emptiness left by neglect.',
      reflection: 'How can I show God\'s attentive love to those who experienced neglect?',
      scripture: 'Can a woman forget her nursing child, that she should have no compassion on the son of her womb? Even these may forget, yet I will not forget you. (Isaiah 49:15)'
    },
    {
      day: 4,
      title: 'Day 4 - Recognizing Unrecognized Trauma',
      content: [
        'Loving Father, some carry wounds from childhood that they do not even recognize as trauma. These hidden wounds still affect their lives in unseen ways.',
        '',
        'Grant deeper knowledge of ourselves - help us to recognize the ways that childhood experiences have shaped us, for better or for worse.',
        '',
        'Shine Your light into the hidden places of our hearts, revealing what needs healing.'
      ],
      prayer: 'Lord Jesus, reveal to us the hidden wounds that need Your healing touch.',
      reflection: 'What patterns in my life might be connected to childhood experiences I haven\'t fully processed?',
      scripture: 'Search me, O God, and know my heart! Try me and know my thoughts! (Psalm 139:23)'
    },
    {
      day: 5,
      title: 'Day 5 - Perseverance in Recovery',
      content: [
        'Loving Father, healing from childhood trauma is not a quick process. It requires perseverance through difficult emotions and painful memories.',
        '',
        'Help all who are on the journey of healing to grow in perseverance. When the road is long and hard, give them strength to continue.',
        '',
        'Remind them that healing is possible and that You walk with them every step of the way.'
      ],
      prayer: 'Lord Jesus, grant perseverance to all who are working through childhood trauma.',
      reflection: 'How can I support someone on the long journey of healing from trauma?',
      scripture: 'Let us not grow weary of doing good, for in due season we will reap, if we do not give up. (Galatians 6:9)'
    },
    {
      day: 6,
      title: 'Day 6 - Humility to Seek Help',
      content: [
        'Loving Father, healing often requires the help of others - counselors, therapists, spiritual directors, and support groups. But asking for help requires humility.',
        '',
        'Help all who need healing from childhood trauma to grow in humility and to seek the help they need. Remove any shame or pride that prevents them from reaching out.',
        '',
        'Bless all who work to help trauma survivors heal, and guide them in their important work.'
      ],
      prayer: 'Lord Jesus, grant humility to seek help and gratitude for those who provide it.',
      reflection: 'Is there help I need to seek for my own healing that I have been avoiding?',
      scripture: 'Bear one another\'s burdens, and so fulfill the law of Christ. (Galatians 6:2)'
    },
    {
      day: 7,
      title: 'Day 7 - Self-Knowledge and Understanding',
      content: [
        'Loving Father, healing requires understanding how trauma has affected us. Self-knowledge is an important step on the path to wholeness.',
        '',
        'Grant the gift of self-knowledge to all who are healing from childhood trauma. Help them to understand their triggers, patterns, and reactions.',
        '',
        'May this understanding lead not to self-condemnation but to self-compassion and growth.'
      ],
      prayer: 'Lord Jesus, grant self-knowledge that leads to healing and growth.',
      reflection: 'What have I learned about myself through my healing journey?',
      scripture: 'And you will know the truth, and the truth will set you free. (John 8:32)'
    },
    {
      day: 8,
      title: 'Day 8 - Building Trust',
      content: [
        'Loving Father, childhood trauma often damages our ability to trust - to trust others and to trust You. Rebuilding trust is essential to healing.',
        '',
        'Help all who struggle with trust because of childhood trauma to grow in trust in God. Show them Your faithfulness and reliability.',
        '',
        'Grant also the discernment to know who is trustworthy and the courage to risk trusting again.'
      ],
      prayer: 'Lord Jesus, rebuild our capacity to trust in You and in others.',
      reflection: 'How has trauma affected my ability to trust? How is God helping me rebuild trust?',
      scripture: 'Trust in the Lord with all your heart, and do not lean on your own understanding. (Proverbs 3:5)'
    },
    {
      day: 9,
      title: 'Day 9 - Offering Suffering Redemptively',
      content: [
        'Loving Father, as we conclude this novena, we ask for the grace to offer our suffering to You for the good of others. What was meant for evil, You can transform for good.',
        '',
        'Help all who have suffered childhood trauma to offer all suffering to You. May their pain become a source of compassion for others who suffer.',
        '',
        'Transform wounds into wisdom, pain into compassion, and trauma into testimony of Your healing power.'
      ],
      prayer: 'Lord Jesus, transform our suffering into a source of healing for others.',
      reflection: 'How can my own wounds become a source of compassion and help for others?',
      scripture: 'Blessed be the God and Father of our Lord Jesus Christ...who comforts us in all our affliction, so that we may be able to comfort those who are in any affliction. (2 Corinthians 1:3-4)'
    }
  ],
  'st-carlo-acutis': [
    {
      day: 1,
      title: 'Day 1 - The Eucharist as Highway to Heaven',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'How can I make the Eucharist more central to my daily life, as Carlo did?',
      scripture: 'I am the living bread that came down from heaven. Whoever eats this bread will live forever. (John 6:51)'
    },
    {
      day: 2,
      title: 'Day 2 - Using Technology for Good',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo used his computer skills to create a website cataloging Eucharistic miracles. How can I use technology to spread the faith?',
      scripture: 'Go into all the world and proclaim the gospel to the whole creation. (Mark 16:15)'
    },
    {
      day: 3,
      title: 'Day 3 - Holiness in Youth',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo became holy as a teenager. How can young people today pursue holiness in their everyday lives?',
      scripture: 'Don\'t let anyone look down on you because you are young, but set an example for the believers. (1 Timothy 4:12)'
    },
    {
      day: 4,
      title: 'Day 4 - Love for the Poor',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo saved his pocket money to help the poor and homeless. How can I be more generous to those in need?',
      scripture: 'Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me. (Matthew 25:40)'
    },
    {
      day: 5,
      title: 'Day 5 - Daily Prayer and Confession',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo attended daily Mass and went to Confession weekly. How can I strengthen my sacramental life?',
      scripture: 'If we confess our sins, he is faithful and just and will forgive us our sins and purify us from all unrighteousness. (1 John 1:9)'
    },
    {
      day: 6,
      title: 'Day 6 - Joy in Suffering',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'When diagnosed with leukemia, Carlo offered his sufferings for the Pope and the Church. How can I unite my sufferings to Christ\'s?',
      scripture: 'Now I rejoice in what I am suffering for you, and I fill up in my flesh what is still lacking in regard to Christ\'s afflictions. (Colossians 1:24)'
    },
    {
      day: 7,
      title: 'Day 7 - Being Original, Not a Copy',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo said, "Everyone is born as an original, but many die as photocopies." How can I be authentically myself while following Christ?',
      scripture: 'For we are God\'s handiwork, created in Christ Jesus to do good works, which God prepared in advance for us to do. (Ephesians 2:10)'
    },
    {
      day: 8,
      title: 'Day 8 - Devotion to Mary',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo prayed the rosary daily and had deep devotion to Mary. How can I grow closer to our Blessed Mother?',
      scripture: 'Standing by the cross of Jesus were his mother and his mother\'s sister. (John 19:25)'
    },
    {
      day: 9,
      title: 'Day 9 - Heaven as Our Goal',
      content: [
        'Dear Father, who has given us the ardent testimony of the young Servant of God, Carlo Acutis, who made the Eucharist the core of his life and strength of his daily commitments so that everybody may love You above all else, let him soon be counted among the Blessed and Saints in Your Church.',
        '',
        'Confirm my Faith, nurture my Hope, strengthen my Charity in the image of young Carlo, who, growing in these virtues, now lives with You.',
        '',
        'I trust in you, Father, and your Beloved Son Jesus, in the Virgin Mary, our Dearest Mother, and in the intervention of Your Servant, Carlo Acutis.'
      ],
      prayer: '"To always be close to Jesus, that\'s my life plan." "The Sacrament of the Eucharist: My Highway to Heaven." St. Carlo Acutis, pray for us!',
      reflection: 'Carlo lived his short life with eternity in view. How can I keep heaven as my ultimate goal in all I do?',
      scripture: 'Set your minds on things above, not on earthly things. (Colossians 3:2)'
    }
  ],
  'st-isidore': [
    {
      day: 1,
      title: 'Day 1 - The Dignity of Work',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for all who work the land, that they may find dignity and meaning in their labor.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'How can I find holiness in my daily work, no matter how humble it may seem?',
      scripture: 'Whatever you do, work heartily, as for the Lord and not for men. (Colossians 3:23)'
    },
    {
      day: 2,
      title: 'Day 2 - Prayer and Work Together',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray that we may learn to unite our prayer and work as you did, attending daily Mass before going to the fields.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'How can I better integrate prayer into my daily work and responsibilities?',
      scripture: 'Pray without ceasing. (1 Thessalonians 5:17)'
    },
    {
      day: 3,
      title: 'Day 3 - Trust in Divine Providence',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for trust in God\'s providence, as you trusted that God would provide for your needs.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'Do I trust that God will provide for my needs when I put Him first?',
      scripture: 'But seek first the kingdom of God and his righteousness, and all these things will be added to you. (Matthew 6:33)'
    },
    {
      day: 4,
      title: 'Day 4 - Generosity to the Poor',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for a generous heart like yours, which shared freely with the poor and hungry.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'Am I generous with what I have, sharing with those in need?',
      scripture: 'Give to the one who asks you, and do not turn away from the one who wants to borrow from you. (Matthew 5:42)'
    },
    {
      day: 5,
      title: 'Day 5 - Humility in Service',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for humility, as you served your employer faithfully without seeking recognition or advancement.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'Can I serve faithfully in my current position without seeking recognition?',
      scripture: 'Whoever wants to become great among you must be your servant. (Matthew 20:26)'
    },
    {
      day: 6,
      title: 'Day 6 - Angels Among Us',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we give thanks for the angels who assisted you in the fields, and we pray for awareness of God\'s supernatural help in our lives.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'Do I recognize and give thanks for God\'s help in my daily life?',
      scripture: 'For he will command his angels concerning you to guard you in all your ways. (Psalm 91:11)'
    },
    {
      day: 7,
      title: 'Day 7 - Marriage and Family',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for all married couples, remembering your holy marriage to St. Maria de la Cabeza, with whom you shared a life of prayer and service.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'How can I grow in holiness with my family and loved ones?',
      scripture: 'Two are better than one, because they have a good return for their labor. (Ecclesiastes 4:9)'
    },
    {
      day: 8,
      title: 'Day 8 - Care for Creation',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'Today we pray for good stewardship of God\'s creation, as you cared for the land and animals entrusted to you.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'How can I be a better steward of God\'s creation?',
      scripture: 'The Lord God took the man and put him in the Garden of Eden to work it and take care of it. (Genesis 2:15)'
    },
    {
      day: 9,
      title: 'Day 9 - Feeding the Hungry',
      content: [
        'Dear St. Isidore, you know how normal it is to cultivate the land, for you were employed as a farm laborer most of your life. Although you received God\'s help materially through Angels in the field, all farmers are aided spiritually to see the wonders God has strewn on this earth.',
        '',
        'Encourage all farmers in their labors and help them to feed many people.',
        '',
        'As we conclude this novena, we pray for all who work to provide food for others, and for an end to hunger in our world.'
      ],
      prayer: 'St. Isidore the Farmer, pray for us!',
      reflection: 'How can I help feed the hungry, both physically and spiritually?',
      scripture: 'For I was hungry and you gave me something to eat, I was thirsty and you gave me something to drink. (Matthew 25:35)'
    }
  ],
  'padre-pio': [
    {
      day: 1,
      title: 'Day 1 - The Gift of the Stigmata',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'Endowed with the gift of discernment, St. Pio labored endlessly in the confessional for the salvation of souls. With reverence and intense devotion in the celebration of Mass, he invited countless men and women to a greater union with Jesus Christ in the Sacrament of the Holy Eucharist.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'How can I unite my own sufferings with the Passion of Christ?',
      scripture: 'I have been crucified with Christ and I no longer live, but Christ lives in me. (Galatians 2:20)'
    },
    {
      day: 2,
      title: 'Day 2 - Humility and Faith',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio, you are a miracle worker and have been blessed with many spiritual gifts. Please intercede before Our Lord for my intentions. Through your humility and faith, help me to recognize Christ in the poor and suffering.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'Do I recognize Christ in those who are poor, suffering, or marginalized?',
      scripture: 'Blessed are the poor in spirit, for theirs is the kingdom of heaven. (Matthew 5:3)'
    },
    {
      day: 3,
      title: 'Day 3 - Perseverance Through Trials',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio, you endured great suffering and persecution with patience and joy. Help me to persevere through my own trials and difficulties, trusting in God\'s love and providence.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'How do I respond when facing trials and difficulties in my life?',
      scripture: 'Consider it pure joy, my brothers and sisters, whenever you face trials of many kinds. (James 1:2)'
    },
    {
      day: 4,
      title: 'Day 4 - Devotion to Mary',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio had a deep devotion to the Blessed Virgin Mary, praying the Rosary daily. Help me to grow in love for our Blessed Mother and to seek her intercession in all my needs.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'How can I deepen my devotion to the Blessed Virgin Mary?',
      scripture: 'Behold your mother. (John 19:27)'
    },
    {
      day: 5,
      title: 'Day 5 - The Gift of Confession',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio spent countless hours in the confessional, bringing souls back to God through the Sacrament of Reconciliation. Help me to value this sacrament and to approach it with sincere contrition.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'When did I last receive the Sacrament of Reconciliation with a contrite heart?',
      scripture: 'If we confess our sins, he is faithful and just and will forgive us our sins. (1 John 1:9)'
    },
    {
      day: 6,
      title: 'Day 6 - Love for the Eucharist',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio celebrated Mass with such devotion that it often lasted for hours. His love for the Eucharist was profound. Help me to receive our Lord in the Eucharist with greater reverence and love.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'How can I prepare myself better to receive the Eucharist worthily?',
      scripture: 'I am the living bread that came down from heaven. (John 6:51)'
    },
    {
      day: 7,
      title: 'Day 7 - Trust in Divine Mercy',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio trusted completely in the mercy of God. He said, "Have courage and do not fear the assaults of the Devil. Remember this forever; it is a healthy sign if the devil shouts and roars around your conscience, since this shows that he is not inside your will."',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'Do I trust in God\'s mercy, even when I feel unworthy?',
      scripture: 'The Lord is compassionate and gracious, slow to anger, abounding in love. (Psalm 103:8)'
    },
    {
      day: 8,
      title: 'Day 8 - Prayer Without Ceasing',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'St. Padre Pio was a man of constant prayer. He said, "Prayer is the best weapon we possess. It is the key that opens the heart of God." Help me to develop a deeper life of prayer.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'How can I make prayer a more constant part of my daily life?',
      scripture: 'Pray without ceasing. (1 Thessalonians 5:17)'
    },
    {
      day: 9,
      title: 'Day 9 - The Blessed Homeland',
      content: [
        'Dear God, You have generously blessed Your servant, St. Pio of Pietrelcina, with the gifts of the Spirit. You marked his body with the five wounds of Christ Crucified, as a powerful witness to the saving Passion and Death of Your Son.',
        '',
        'As we conclude this novena, we ask St. Padre Pio to accompany us toward the blessed Homeland, where we hope to praise God eternally. Grant us perseverance in faith until we reach our heavenly home.',
        '',
        'Through the intercession of St. Pio of Pietrelcina, I confidently beseech You to grant me the grace I seek.'
      ],
      prayer: 'St. Padre Pio, pray for us! Glory be to the Father, and to the Son, and to the Holy Spirit.',
      reflection: 'Am I living my life with heaven as my ultimate goal?',
      scripture: 'In my Father\'s house are many rooms...I am going there to prepare a place for you. (John 14:2)'
    }
  ],
  'infant-of-prague': [
    {
      day: 1,
      title: 'Day 1 - Poverty of Spirit',
      content: [
        'O Infant Jesus, I come before You with humble confidence. You who came into this world in poverty, born in a stable and laid in a manger, teach me to be poor in spirit.',
        '',
        'The first Beatitude promises the Kingdom of Heaven to those who are poor in spirit. Help me to detach from worldly possessions and to find my treasure in You alone.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'O Jesus, Who said, "Ask and you shall receive," through the intercession of Mary, Your Most Holy Mother, I ask that my prayer be granted.',
      reflection: 'What attachments do I need to release to become poor in spirit?',
      scripture: 'Blessed are the poor in spirit, for theirs is the kingdom of heaven. (Matthew 5:3)'
    },
    {
      day: 2,
      title: 'Day 2 - Comfort in Mourning',
      content: [
        'O Infant Jesus, even at Your birth there was sorrow - the lack of room at the inn, the flight into Egypt, the threat of Herod. You understand our mourning and grief.',
        '',
        'The second Beatitude promises comfort to those who mourn. In my times of grief and sorrow, be my consolation. Help me to trust that You will wipe away every tear.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'O Jesus, Who said, "Seek and you shall find," through the intercession of Mary, Your Most Holy Mother, I seek Your comfort in my sorrows.',
      reflection: 'What sorrows do I need to bring to Jesus for comfort and healing?',
      scripture: 'Blessed are those who mourn, for they will be comforted. (Matthew 5:4)'
    },
    {
      day: 3,
      title: 'Day 3 - The Gift of Meekness',
      content: [
        'O Infant Jesus, You came into this world as a gentle, helpless baby. You did not come with power and might, but with meekness and humility.',
        '',
        'The third Beatitude promises that the meek will inherit the earth. Transform my heart to be gentle and humble like Yours. Help me to respond to others with patience and kindness.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'O Jesus, Who said, "Knock and it shall be opened to you," through the intercession of Mary, Your Most Holy Mother, I knock at the door of Your heart.',
      reflection: 'In what situations do I need to respond with greater meekness?',
      scripture: 'Blessed are the meek, for they will inherit the earth. (Matthew 5:5)'
    },
    {
      day: 4,
      title: 'Day 4 - Hunger for Righteousness',
      content: [
        'O Infant Jesus, as a baby You experienced physical hunger and dependence. Teach me to hunger and thirst for righteousness as intensely as the body hungers for food.',
        '',
        'The fourth Beatitude promises satisfaction to those who hunger for righteousness. Fill me with a desire for holiness and justice. Help me to seek what is right above all else.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, I believe in Your promise of peace, blessings, and freedom from want.',
      reflection: 'Do I hunger for righteousness as much as I hunger for worldly things?',
      scripture: 'Blessed are those who hunger and thirst for righteousness, for they will be filled. (Matthew 5:6)'
    },
    {
      day: 5,
      title: 'Day 5 - The Call to Mercy',
      content: [
        'O Infant Jesus, You came into this world as a vulnerable child, dependent on the mercy and care of others. Your entire life would be a revelation of the Father\'s mercy.',
        '',
        'The fifth Beatitude promises mercy to the merciful. Help me to show mercy to others as You have shown mercy to me. May I forgive as I have been forgiven.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, I place every need and care in Your hands.',
      reflection: 'Who in my life needs to receive mercy and forgiveness from me?',
      scripture: 'Blessed are the merciful, for they will be shown mercy. (Matthew 5:7)'
    },
    {
      day: 6,
      title: 'Day 6 - Purity of Heart',
      content: [
        'O Infant Jesus, Mary gazed upon You with the purest heart, and in You she saw God. Grant me purity of heart that I may see God in all things.',
        '',
        'The sixth Beatitude promises that the pure in heart will see God. Purify my heart of all that is not of You. Help me to see with the eyes of faith.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, may I always trust in Your generous mercy and love.',
      reflection: 'What impurities in my heart prevent me from seeing God clearly?',
      scripture: 'Blessed are the pure in heart, for they will see God. (Matthew 5:8)'
    },
    {
      day: 7,
      title: 'Day 7 - Peacemaking',
      content: [
        'O Infant Jesus, at Your birth the angels proclaimed peace on earth. Shepherds and wise men came together in harmony to adore You. You are the Prince of Peace.',
        '',
        'The seventh Beatitude promises that peacemakers will be called children of God. Help me to be an instrument of Your peace in my family, community, and world.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, I want to honor and praise You, now and forever.',
      reflection: 'Where can I bring peace to situations of conflict in my life?',
      scripture: 'Blessed are the peacemakers, for they will be called children of God. (Matthew 5:9)'
    },
    {
      day: 8,
      title: 'Day 8 - Perseverance in Persecution',
      content: [
        'O Infant Jesus, even as a child You faced persecution. Herod sought to destroy You, and Your family had to flee to Egypt. You understand the suffering of the persecuted.',
        '',
        'The eighth Beatitude promises the Kingdom of Heaven to those persecuted for righteousness. Grant me courage to stand firm in faith even when I face opposition.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, I know You love me and would never leave me.',
      reflection: 'How do I respond when my faith is challenged or ridiculed?',
      scripture: 'Blessed are those who are persecuted because of righteousness, for theirs is the kingdom of heaven. (Matthew 5:10)'
    },
    {
      day: 9,
      title: 'Day 9 - The Mystery of the Incarnation',
      content: [
        'O Infant Jesus, as we conclude this novena, we meditate on the great mystery of the Incarnation - that God became a human child for our salvation.',
        '',
        'You are the King of Kings, yet You came as a helpless infant. You hold the universe in Your hands, yet You allowed Yourself to be held in Mary\'s arms. Help me to understand and embrace this mystery of love.',
        '',
        'I place my intentions before You, trusting in Your love and mercy.'
      ],
      prayer: 'Divine Infant Jesus, I thank You for Your close presence in my life. Amen.',
      reflection: 'How does the mystery of God becoming a child change how I understand God\'s love?',
      scripture: 'The Word became flesh and made his dwelling among us. (John 1:14)'
    }
  ],
  'our-lady-perpetual-help': [
    {
      day: 1,
      title: 'Day 1 - Growth in Marian Devotion',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, I thank God for the gift of your intercession in my life. You are the one who always helps those who call upon you.',
        '',
        'Today I ask for your help in growing in devotion to you. Teach me to love your Son Jesus as you love Him, and to turn to you in all my needs with confidence and trust.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I grow in my devotion to Mary and trust in her intercession?',
      scripture: 'His mother said to the servants, "Do whatever he tells you." (John 2:5)'
    },
    {
      day: 2,
      title: 'Day 2 - The Gift of Motherhood',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, you are the Mother of God and our Mother too. Jesus gave you to us from the Cross when He said to John, "Behold your mother."',
        '',
        'Today I pray for all mothers and for those who long for the gift of motherhood. May all mothers follow your example of love, patience, and faith.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I honor the gift of motherhood in my life?',
      scripture: 'When Jesus saw his mother there, and the disciple whom he loved standing nearby, he said to her, "Woman, here is your son." (John 19:26)'
    },
    {
      day: 3,
      title: 'Day 3 - Offering Suffering',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, you stood at the foot of the Cross and watched your Son suffer for our salvation. You know the meaning of suffering united to Christ.',
        '',
        'Today I offer my sufferings to God through your hands. Help me to see my trials as opportunities to grow closer to Jesus and to share in His redemptive work.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I unite my sufferings with Christ\'s for the good of others?',
      scripture: 'Near the cross of Jesus stood his mother. (John 19:25)'
    },
    {
      day: 4,
      title: 'Day 4 - Religious Vocations',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, you said "yes" to God\'s call to be the Mother of the Savior. Your fiat changed the course of human history.',
        '',
        'Today I pray for all who are discerning a religious vocation. May they have the courage to say "yes" to God\'s call, and may the Church never lack holy priests and religious.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I support and pray for vocations to the priesthood and religious life?',
      scripture: 'I am the Lord\'s servant. May your word to me be fulfilled. (Luke 1:38)'
    },
    {
      day: 5,
      title: 'Day 5 - Renewal of the Redemptorist Order',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, the Redemptorist Fathers have been entrusted with spreading devotion to you throughout the world. They guard your icon in Rome.',
        '',
        'Today I pray for the renewal of the Redemptorist Order and all religious communities devoted to you. May they continue to spread your message of hope and help to all in need.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I support religious communities in their mission?',
      scripture: 'Go into all the world and preach the gospel to all creation. (Mark 16:15)'
    },
    {
      day: 6,
      title: 'Day 6 - Spiritual Courage',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, you had the courage to accept God\'s will even when you did not fully understand it. You trusted in His plan for your life.',
        '',
        'Today I ask for spiritual courage to face the challenges in my life. When I am afraid or uncertain, help me to trust in God\'s loving plan for me.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'What fears do I need to surrender to God\'s loving care?',
      scripture: 'Do not be afraid, Mary; you have found favor with God. (Luke 1:30)'
    },
    {
      day: 7,
      title: 'Day 7 - Growth in Piety',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, you treasured all things in your heart and pondered them. Your life was one of deep prayer and communion with God.',
        '',
        'Today I ask for growth in piety and devotion. Help me to develop a rich prayer life and to find joy in worship and in the sacraments.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I deepen my prayer life and grow in devotion?',
      scripture: 'But Mary treasured up all these things and pondered them in her heart. (Luke 2:19)'
    },
    {
      day: 8,
      title: 'Day 8 - Trust in Divine Providence',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, throughout your life you trusted in God\'s providence, even when the path was unclear. You believed that God would provide.',
        '',
        'Today I ask for greater trust in divine providence. Help me to let go of my anxieties and to believe that God is working all things for my good.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'What worries do I need to surrender to God\'s providence?',
      scripture: 'And we know that in all things God works for the good of those who love him. (Romans 8:28)'
    },
    {
      day: 9,
      title: 'Day 9 - Holiness of the Church',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O Mother of Perpetual Help, as we conclude this novena, we pray for the holiness of the Church. You are the Mother of the Church, watching over all her children.',
        '',
        'Today I dedicate myself anew to God through your intercession. Help the Church to grow in holiness and to be a beacon of hope for the world.'
      ],
      prayer: 'Our Lady of Perpetual Help, pray for us!',
      reflection: 'How can I contribute to the holiness of the Church through my own growth in virtue?',
      scripture: 'Christ loved the church and gave himself up for her to make her holy. (Ephesians 5:25-26)'
    }
  ],
  'st-rita': [
    {
      day: 1,
      title: 'Day 1 - Compassion for Christ\'s Suffering',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, you received the stigmata - a wound from the crown of thorns - and shared in Jesus\' passion through your suffering. You understood the redemptive value of suffering united to Christ.',
        '',
        'O God, in Your infinite tenderness You have been pleased to regard the prayer of Your servant Rita, and to grant to her supplication that which is impossible to human foresight, skill, and effort.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'How can I unite my sufferings to Christ\'s Passion?',
      scripture: 'I want to know Christ—yes, to know the power of his resurrection and participation in his sufferings. (Philippians 3:10)'
    },
    {
      day: 2,
      title: 'Day 2 - The Power of Forgiveness',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, when your husband was murdered, you hid his bloodied clothes to prevent your sons from seeking revenge. You taught us that forgiveness is stronger than vengeance.',
        '',
        'Grant us the grace to forgive those who have hurt us, as you forgave those who wronged your family.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'Is there someone I need to forgive? What is holding me back?',
      scripture: 'Forgive us our debts, as we also have forgiven our debtors. (Matthew 6:12)'
    },
    {
      day: 3,
      title: 'Day 3 - Heroic Virtue',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, your life was marked by heroic virtue. Despite a difficult marriage and great personal tragedy, you remained faithful to God and grew in holiness.',
        '',
        'Help us to imitate your inspiring virtue and your closeness to God, that we too may become saints.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'What virtue do I most need to develop in my life?',
      scripture: 'Be perfect, therefore, as your heavenly Father is perfect. (Matthew 5:48)'
    },
    {
      day: 4,
      title: 'Day 4 - Faith as Strength',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, your belief in God\'s love sustained you through life\'s difficulties. When doors closed before you, you trusted that God had a plan.',
        '',
        'Grant us faith that can withstand any trial, knowing that God\'s love never fails.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'How has faith helped me through difficult times?',
      scripture: 'Now faith is confidence in what we hope for and assurance about what we do not see. (Hebrews 11:1)'
    },
    {
      day: 5,
      title: 'Day 5 - The Gift of Patience',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, you endured grief and deprivation with remarkable patience. Three times you applied to enter the convent and three times you were refused, yet you persevered.',
        '',
        'Help us to develop patience through your example, trusting in God\'s timing.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'Where do I need to practice greater patience in my life?',
      scripture: 'Be patient, then, brothers and sisters, until the Lord\'s coming. (James 5:7)'
    },
    {
      day: 6,
      title: 'Day 6 - Prayer and Communion with God',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, your life was marked by constant dialogue with God through prayer. You sought His will in all things and found strength in communion with Him.',
        '',
        'Teach us to pray as you did, maintaining constant conversation with our Lord.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'How can I deepen my prayer life and communion with God?',
      scripture: 'Devote yourselves to prayer, being watchful and thankful. (Colossians 4:2)'
    },
    {
      day: 7,
      title: 'Day 7 - Christian Charity',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, you were known for your generous spiritual and material giving. You cared for the sick and the poor with great love.',
        '',
        'Help us to imitate your charity, giving generously of ourselves to those in need.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'How can I be more generous in my service to others?',
      scripture: 'Dear children, let us not love with words or speech but with actions and in truth. (1 John 3:18)'
    },
    {
      day: 8,
      title: 'Day 8 - Hope in God',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, you developed unwavering hope in divine providence despite earthly anguish. When all seemed lost, you trusted in God\'s plan.',
        '',
        'Grant us hope that does not disappoint, even in our darkest moments.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'What gives me hope when circumstances seem hopeless?',
      scripture: 'And hope does not put us to shame, because God\'s love has been poured out into our hearts. (Romans 5:5)'
    },
    {
      day: 9,
      title: 'Day 9 - Steadfast Faith',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'O glorious St. Rita, as we conclude this novena, we ask for strengthening of our faith through your example of consistent belief. You are called the Saint of the Impossible because nothing is impossible with God.',
        '',
        'We have confidence that everyone who has recourse to you will find comfort and relief. Present our intentions to God, who can do all things.'
      ],
      prayer: 'St. Rita, Patroness of Impossible Causes, pray for us!',
      reflection: 'What "impossible" situation do I need to entrust to God\'s care?',
      scripture: 'For nothing will be impossible with God. (Luke 1:37)'
    }
  ],
  'st-michael': [
    {
      day: 1,
      title: 'Day 1 - Strength and Rejection of Sin',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, you are a powerful protector of the Church and guardian of our souls. Inspire us with your humility, courage, and strength that we may reject sin and perfect our love for our Heavenly Father.',
        '',
        'In your strength and humility, slay the evil and pride in our hearts so that nothing will keep us from God.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'What sins do I need strength to reject and overcome?',
      scripture: 'And there was war in heaven. Michael and his angels fought against the dragon. (Revelation 12:7)'
    },
    {
      day: 2,
      title: 'Day 2 - Seeing God\'s Image in Others',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, you are the prince of angels, but in your humility you recognized that God is God and you are but His servant. Unlike satan, you were not overcome with pride but were steadfast in humility.',
        '',
        'Grant us the grace to see God\'s image in every person we encounter, treating all with dignity and respect.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'Do I see God\'s image in everyone, especially those who are difficult to love?',
      scripture: 'So God created mankind in his own image, in the image of God he created them. (Genesis 1:27)'
    },
    {
      day: 3,
      title: 'Day 3 - Protection from Temptation',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, you cast satan and the rebellious angels out of heaven. You are our defender against the temptations and attacks of the evil one.',
        '',
        'Protect us from temptation and sin. Shield us from the snares of the devil and help us to choose what is good and holy.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'What temptations do I struggle with most? How can St. Michael help me?',
      scripture: 'No temptation has overtaken you except what is common to mankind. (1 Corinthians 10:13)'
    },
    {
      day: 4,
      title: 'Day 4 - Desire to Serve God\'s Will',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, your very name means "Who is like God?" This was your battle cry against the pride of satan. You chose to serve God rather than yourself.',
        '',
        'Grant us the desire to serve God\'s will humbly, putting His plans above our own desires.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'Am I truly seeking God\'s will, or am I following my own plans?',
      scripture: 'Your kingdom come, your will be done, on earth as it is in heaven. (Matthew 6:10)'
    },
    {
      day: 5,
      title: 'Day 5 - The Gift of Humility',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, though you are the prince of angels, you remain humble before God. You did not seek glory for yourself but gave all glory to God.',
        '',
        'Pray that we will have this same humility, recognizing our place before our Creator.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'In what areas of my life do I need to grow in humility?',
      scripture: 'Humble yourselves before the Lord, and he will lift you up. (James 4:10)'
    },
    {
      day: 6,
      title: 'Day 6 - Faith to Trust in God\'s Care',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, you trusted completely in God when you battled against the forces of evil. Your faith in God\'s power never wavered.',
        '',
        'Grant us faith to trust in God\'s care for us, even when we face spiritual battles and difficulties.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'Do I trust that God is protecting and caring for me?',
      scripture: 'The angel of the Lord encamps around those who fear him, and he delivers them. (Psalm 34:7)'
    },
    {
      day: 7,
      title: 'Day 7 - Dedication to God\'s Glory',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, all your actions are directed to the glory of God. You serve Him with perfect love and dedication.',
        '',
        'Help us to dedicate all our actions to God\'s glory, doing everything for love of Him.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'Do my daily actions give glory to God?',
      scripture: 'So whether you eat or drink or whatever you do, do it all for the glory of God. (1 Corinthians 10:31)'
    },
    {
      day: 8,
      title: 'Day 8 - Obedience to God\'s Commandments',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, you obeyed God\'s command to cast out the rebellious angels. Your obedience was swift and complete.',
        '',
        'Grant us the will to obey God\'s commandments faithfully, even when it is difficult.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil.',
      reflection: 'Which of God\'s commandments do I find most difficult to obey?',
      scripture: 'If you love me, keep my commands. (John 14:15)'
    },
    {
      day: 9,
      title: 'Day 9 - Grace to Share Eternity with God',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Michael the Archangel, as we conclude this novena, we ask for the grace to share eternity with God. Lead us safely through the battles of this life to our heavenly home.',
        '',
        'May God rebuke the devil, we humbly pray. And do thou, O Prince of the heavenly hosts, by the power of God, cast into hell satan, and all the evil spirits, who prowl about the world seeking the ruin of souls.'
      ],
      prayer: 'St. Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil. Amen.',
      reflection: 'Am I living my life with eternity in view?',
      scripture: 'Then the righteous will shine like the sun in the kingdom of their Father. (Matthew 13:43)'
    }
  ],
  'st-gerard': [
    {
      day: 1,
      title: 'Day 1 - The Gift of Faith',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, ever full of faith, obtain for me that, believing firmly all that the Church of God proposes to my belief, I may strive to secure through a holy life, the joys of eternal happiness.',
        '',
        'You showed us that faith is the foundation of all virtue. Help me to grow in faith each day.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How strong is my faith? What can I do to strengthen it?',
      scripture: 'Now faith is confidence in what we hope for and assurance about what we do not see. (Hebrews 11:1)'
    },
    {
      day: 2,
      title: 'Day 2 - Poverty of Spirit',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, most generous saint, who from your tenderest years did care so little for the goods of earth, grant that I may place all my confidence in Jesus Christ alone, my true Treasure, who alone can make me happy in time and eternity.',
        '',
        'Help me to be detached from worldly possessions and to find my wealth in Christ.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'Am I too attached to material things? What do I truly treasure?',
      scripture: 'Do not store up for yourselves treasures on earth...but store up for yourselves treasures in heaven. (Matthew 6:19-20)'
    },
    {
      day: 3,
      title: 'Day 3 - Charity and Love',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, bright seraph of love, who despising all earthly love, did consecrate your life to the service of God and your neighbor, obtain for me, I beseech you, that loving God the only good and my neighbor for His sake, I may be hereafter united to Him forever in glory.',
        '',
        'Teach me to love God above all things and my neighbor as myself.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How do I show love for God and for my neighbor in my daily life?',
      scripture: 'Love the Lord your God with all your heart...Love your neighbor as yourself. (Mark 12:30-31)'
    },
    {
      day: 4,
      title: 'Day 4 - The Gift of Purity',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, spotless lily of purity, by the angelic virtue and your wonderful innocence of life you did receive from the Infant Jesus and His Immaculate Mother sweet pledges of tender love.',
        '',
        'Grant, I beseech you, that I may ever strive manfully in my lifelong fight, and therefore win the crown that awaits the brave and the true.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How can I grow in purity of heart, mind, and body?',
      scripture: 'Blessed are the pure in heart, for they will see God. (Matthew 5:8)'
    },
    {
      day: 5,
      title: 'Day 5 - Holy Obedience',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, model of holy obedience, who through your life did heroically submit your judgment to those who represent Jesus Christ to you, obtain for me from God cheerful submission to His Holy Will and the virtue of perfect obedience.',
        '',
        'Help me to be made conformable to Jesus, my Model, who was obedient even to death.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'Am I obedient to God\'s will and to legitimate authority?',
      scripture: 'And being found in appearance as a man, he humbled himself by becoming obedient to death. (Philippians 2:8)'
    },
    {
      day: 6,
      title: 'Day 6 - The Virtue of Humility',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, most perfect imitator of Jesus Our Redeemer, you whose greatest glory was to be humble and lowly, obtain that I too, knowing my littleness in God\'s sight may be found worthy to enter the kingdom that is promised to the humble and lowly of heart.',
        '',
        'When falsely accused of sin, you bore it in silence. Teach me your humility.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How do I respond when falsely accused or misunderstood?',
      scripture: 'Whoever takes the lowly position of this child is the greatest in the kingdom of heaven. (Matthew 18:4)'
    },
    {
      day: 7,
      title: 'Day 7 - Patience in Suffering',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, unconquered hero, most patient in suffering, you who did glory in infirmity, and under slander and most cruel ignominy did rejoice to suffer with Christ.',
        '',
        'Obtain for me patience and resignation in my sorrows, that I may bravely bear the cross that is to gain for me the crown of everlasting glory.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How do I bear suffering? Can I find meaning in my trials?',
      scripture: 'We also glory in our sufferings, because we know that suffering produces perseverance. (Romans 5:3)'
    },
    {
      day: 8,
      title: 'Day 8 - Love for the Eucharist',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, true lover of Jesus in the Blessed Sacrament of the Altar, you who did kneel long hours before the Tabernacle, and there did taste the joys of paradise.',
        '',
        'Obtain for me an undying love for the Most Holy Sacrament, that receiving frequently the Body and Blood of Jesus, I may daily grow in His holy love and merit the priceless grace of loving Him even to the end.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How often do I spend time in adoration before the Blessed Sacrament?',
      scripture: 'Whoever eats my flesh and drinks my blood has eternal life. (John 6:54)'
    },
    {
      day: 9,
      title: 'Day 9 - Devotion to Mary',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Saint Gerard, most favorite child of heaven, to whom Mary gave the Infant Jesus in the day of your childhood, to whom she sweetly came before you did close your eyes in death.',
        '',
        'Obtain for me I beseech you, so to seek and love my Blessed Mother during life, that she may be my joy and consolation in this valley of tears, until with you, before the throne of God, I may praise her goodness for all eternity.'
      ],
      prayer: 'St. Gerard Majella, pray for us! Pray for us, O Saint Gerard, that we may be made worthy of the promises of Christ.',
      reflection: 'How can I grow in devotion to Mary, the Mother of God?',
      scripture: 'When Jesus saw his mother there...he said to her, "Woman, here is your son." (John 19:26)'
    }
  ],
  'st-peregrine': [
    {
      day: 1,
      title: 'Day 1 - Protection Against Despair',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'Glorious wonder-worker, St. Peregrine, you answered the divine call with a ready spirit, and forsook all the comforts of a life of ease and all the empty honors of the world to dedicate yourself to God in the Order of His holy Mother.',
        '',
        'Today I ask for your protection against despair during illness. Help me to maintain hope even when the diagnosis seems grim.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'How do I maintain hope when facing serious illness or difficulty?',
      scripture: 'Why, my soul, are you downcast? Put your hope in God. (Psalm 42:11)'
    },
    {
      day: 2,
      title: 'Day 2 - Perseverance in Hope',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, you labored manfully for the salvation of souls. In union with Jesus crucified, you endured painful sufferings with such patience as to deserve to be healed miraculously of an incurable cancer by a touch of His divine hand.',
        '',
        'Grant me perseverance in hope. When treatment is long and difficult, help me to keep trusting in God\'s plan.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'How can I persevere in hope during a long and difficult trial?',
      scripture: 'But if we hope for what we do not yet have, we wait for it patiently. (Romans 8:25)'
    },
    {
      day: 3,
      title: 'Day 3 - Uniting Suffering with Christ',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, you understood the value of suffering united to Christ\'s Passion. The night before your scheduled amputation, you prayed before an image of Christ crucified, and He reached out to heal you.',
        '',
        'Grant me courage to unite my suffering with Christ\'s passion, knowing that united to Him, my suffering has redemptive value.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'Can I offer my suffering for the good of others?',
      scripture: 'I fill up in my flesh what is still lacking in regard to Christ\'s afflictions. (Colossians 1:24)'
    },
    {
      day: 4,
      title: 'Day 4 - Consolation Amid Loneliness',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, illness can be a lonely experience. Long hours in hospital rooms, treatments that isolate us from loved ones - these can be times of great loneliness.',
        '',
        'Obtain for me consolation amid loneliness. Help me to know that Christ is always with me, even in my most isolated moments.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'Do I remember that Christ is with me even when I feel alone?',
      scripture: 'And surely I am with you always, to the very end of the age. (Matthew 28:20)'
    },
    {
      day: 5,
      title: 'Day 5 - Replacing Fear with Hope',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, facing serious illness naturally brings fear - fear of pain, fear of the unknown, fear of death. You faced cancer with faith rather than fear.',
        '',
        'Help me to replace my fear of death with hope of eternal life. May I trust that death is not the end but the beginning of life with God.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'What fears about illness or death do I need to surrender to God?',
      scripture: 'Even though I walk through the darkest valley, I will fear no evil, for you are with me. (Psalm 23:4)'
    },
    {
      day: 6,
      title: 'Day 6 - Preserving Joy Despite Suffering',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, the saints teach us that joy is possible even in suffering. Joy is not the absence of pain but the presence of God.',
        '',
        'Help me to preserve joy despite my suffering. May I find moments of grace and gratitude even in my illness.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'Can I find reasons for joy and gratitude even in difficult times?',
      scripture: 'Consider it pure joy, my brothers and sisters, whenever you face trials of many kinds. (James 1:2)'
    },
    {
      day: 7,
      title: 'Day 7 - Selflessness Rather Than Self-Centeredness',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, illness can make us focus entirely on ourselves - our pain, our treatment, our prognosis. But you continued to serve others even while suffering.',
        '',
        'Help me to develop selflessness rather than self-centeredness. Even in my illness, may I think of others and their needs.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'How can I think of others even while dealing with my own struggles?',
      scripture: 'Do nothing out of selfish ambition...rather, in humility value others above yourselves. (Philippians 2:3)'
    },
    {
      day: 8,
      title: 'Day 8 - Deepening Dependence on God',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, illness strips away our illusions of self-sufficiency. We realize how dependent we are - on doctors, on caregivers, and most of all, on God.',
        '',
        'Help me to deepen my dependence on God. May my illness draw me closer to Him rather than pushing me away.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'Has illness helped me recognize my dependence on God?',
      scripture: 'My grace is sufficient for you, for my power is made perfect in weakness. (2 Corinthians 12:9)'
    },
    {
      day: 9,
      title: 'Day 9 - Living to Glorify God',
      content: [
        'In the name of the Father, and of the Son, and of the Holy Spirit. Amen.',
        '',
        'St. Peregrine, as we conclude this novena, we acknowledge that a life of holiness like yours is more important than a life free of suffering and disease. You glorified God in your illness and in your miraculous healing.',
        '',
        'Grant that whether I am healed or not, I may live to glorify God alone. May my life, however long or short, give praise to Him.'
      ],
      prayer: 'St. Peregrine, patron of cancer patients, pray for us!',
      reflection: 'How can my life - in sickness or in health - give glory to God?',
      scripture: 'So whether you eat or drink or whatever you do, do it all for the glory of God. (1 Corinthians 10:31)'
    }
  ]
};